if (typeof window !== 'undefined' && typeof window.UserLoginStatus !== 'undefined') {
    const userLoginStatus = new window.UserLoginStatus();
    userLoginStatus.init();
} else {


    const UserLoginStatus = class {
        constructor() {
            if (UserLoginStatus.instance) {
                return UserLoginStatus.instance;
            }
            // Token 相关配置
            const APP_ENV = window.renogyConfig.mode;
            this.ACCESS_TOKEN_KEY = `renogy_account_access_token_key_${APP_ENV}_1.0`;
            this.REFRESH_TOKEN_KEY = `renogy_account_refresh_token_key_${APP_ENV}_1.0`;
            
            this.accessToken = this.getCookie(this.ACCESS_TOKEN_KEY);
            this.refreshToken = this.getCookie(this.REFRESH_TOKEN_KEY);
            this.userInfo = null;
            this.merberData = null;
            this.memberCenterProfile = null;
            this.memberCenterAssets = null;
            this.memberCenterMilesTasks = null;
            this.memberCenterRaysTasks = null;
            this.subscribeEmailInfo = null;
            this.pageCouponTemplateData = null;
            this.giftCardCouponData = null;
            this.productCardCouponData = null;
            this.memberDataPromise = null;
            this.memberCenterProfilePromise = null;
            this.memberCenterAssetsPromise = null;
            this.couponDataPromise = null;
            this.giftCardCouponDataPromise = null;
            this.productCardCouponDataPromise = null;
            this.exchangeResult = null;
            this.exchangeGiftCardResult = null;
            this.API_DOMAIN = window.renogyConfig.apiUrl;
            this.customerEmail = null;
            this.isRedeem = true;
            this.recordId = null;
            this.storeId = window.renogyConfig?.storeId || '1';
            // 登录状态标记
            this.isLoggedIn = Boolean(this.accessToken && this.refreshToken);
            this.toastErrorIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <rect x="5" y="5" width="18" height="18" rx="9" stroke="#E04700" stroke-width="2"/>
                <circle cx="14" cy="10.1992" r="1" fill="#E04700"/>
                <rect x="13" y="12" width="2" height="6.8" rx="1" fill="#E04700"/>
            </svg>`
            this.toastTipsIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <rect x="6" y="8" width="16" height="16" rx="8" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            <path d="M14 12V15.6C14 15.8209 14.1791 16 14.4 16H18" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            <line x1="12" y1="5" x2="16" y2="5" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            <path d="M15 7.29961L13 7.29961L13 4.59961L15 4.59961L15 7.29961Z" fill="#00C0FF"/>
            <line x1="20" y1="9.58579" x2="20.99" y2="8.59584" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            </svg>`;
            // Token 刷新相关变量
            this.isRefreshing = false;
            this.refreshPromise = null;
            this.pendingRequests = [];
            this.refreshContainers();

            // Tooltip 相关状态
            this.tooltipInitialized = false;
            this.tooltipEventHandlers = {
                click: null,
                resize: null
            };
            this.globalClickHandlerBound = false;
            this.globalClickHandler = null;
           
            // for test
            if(window.location.hostname === '127.0.0.1') {
                this.apiUrl = 'https://e2f9c05f31c7.ngrok-free.app';
                this.accessToken = 'eyJhbGciOiJIUzUxMiJ9.eyJpZCI6OTAxNzQ2LCJlbWFpbCI6IjE0NDIxMjM1MTBAcXEuY29tIiwic3VwcG9ydF9yZWZyZXNoIjp0cnVlLCJqdGkiOiJZamd4TXpVek1URXROelptWmkwMFlURTVMV0prT1dJdE16RXdNR0kwT1dFNFlUa3kiLCJpYXQiOjE3NjI4NTI2MTksImV4cCI6MTc2MjkzOTAxOX0.cDYktvwkOnDAcB4E_ZLX9nJE4QDQPxgCYVFRL4SZUhWSqcZXY9raCTbS0eUD8OJp7OmRlP7dZo2nLGSY5zvH9g'
                this.refreshToken ='eyJhbGciOiJIUzUxMiJ9.eyJpZCI6OTAxNzQ2LCJpYXQiOjE3NjI4NTI2MTksImp0aSI6Ik1XSTJNemRrT1dJdE16QTJNeTAwTnpBNExXSmhabUV0WVdJNE5EWmhNMkk1WkRNNSJ9.PqWaYWsAy0qcLw2YMbFkgNUzRP3IartjJIifx8Z84lAw8XLOv2k408ail9Xl9HNvW3sRfIRZwrT-98_lmBIKVw'
            }
            else if(window.location.hostname === 'shopify-uk.renogy.cn'){
                this.apiUrl = `https://d-shopify-api.renogy.cn`
            }else{
                this.apiUrl = `https://shopify-api.renogy.com`
            }


            const benefitsIcon = {
                    'first_order_offer': `<svg width="280" height="280" viewBox="0 0 280 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="280" height="280" fill="#F2FCFF"/>
                        <path d="M213.018 148.717C213.487 147.829 214.76 147.829 215.229 148.717L219.95 157.665C220.13 158.007 220.46 158.247 220.842 158.313L230.81 160.038C231.8 160.209 232.194 161.42 231.493 162.141L224.443 169.395C224.173 169.673 224.047 170.061 224.102 170.444L225.542 180.457C225.685 181.452 224.655 182.2 223.753 181.757L214.675 177.293C214.327 177.122 213.92 177.122 213.572 177.293L204.494 181.757C203.592 182.2 202.562 181.452 202.705 180.457L204.145 170.444C204.2 170.061 204.074 169.673 203.804 169.395L196.754 162.141C196.053 161.42 196.446 160.209 197.437 160.038L207.405 158.313C207.787 158.247 208.116 158.007 208.297 157.665L213.018 148.717Z" fill="#0B3587"/>
                        <path d="M151.315 16.2619C152.166 15.7266 153.269 16.3631 153.23 17.3675L152.845 27.4763C152.83 27.8636 152.996 28.2358 153.293 28.484L161.064 34.9617C161.836 35.6053 161.571 36.8505 160.604 37.1245L150.871 39.8817C150.498 39.9873 150.195 40.26 150.051 40.6198L146.292 50.0114C145.918 50.9445 144.652 51.0776 144.093 50.2426L138.463 41.8378C138.247 41.5158 137.894 41.3121 137.507 41.2863L127.414 40.6129C126.411 40.546 125.893 39.383 126.514 38.593L132.768 30.6413C133.007 30.3367 133.092 29.9381 132.997 29.5623L130.518 19.7546C130.272 18.7801 131.218 17.9283 132.162 18.2751L141.657 21.7654C142.02 21.8991 142.426 21.8566 142.754 21.6501L151.315 16.2619Z" fill="#00C0FF"/>
                        <path d="M234.154 82.4853C228.42 81.0823 219.898 79.7715 210.762 88.9066C201.627 98.0416 206.854 109.785 198.445 118.194C190.037 126.603 182.63 122.261 179 120.669" stroke="#0B3587" stroke-width="16" stroke-linecap="round"/>
                        <path d="M174.5 60.6738C178.918 60.6743 182.5 64.2564 182.5 68.6745C182.499 73.0927 178.917 76.6745 174.499 76.6741C173.067 76.674 171.038 76.9972 169.48 77.7709C168.134 78.4402 167.63 79.1376 167.435 80.1171C166.953 82.5429 167.036 83.8045 167.126 84.3857C167.208 84.9067 167.336 85.2453 167.752 86.1088C168.091 86.8136 169.339 89.1108 169.583 91.9949C169.845 95.0964 168.975 97.9553 167.644 100.653C164.653 106.714 160.005 109.911 155.366 111.283C151.094 112.545 147.177 112.142 145.66 111.999C141.261 111.586 138.03 107.685 138.444 103.287C138.857 98.8877 142.758 95.6565 147.157 96.0698C148.59 96.2044 149.775 96.2509 150.831 95.9388C151.284 95.8048 151.659 95.6146 151.996 95.3395C152.323 95.0718 152.803 94.5704 153.295 93.5738C153.395 93.3716 153.484 93.1471 153.416 92.9322C153.376 92.8075 153.315 92.7093 153.295 92.667C152.698 91.4287 151.772 89.7603 151.318 86.8542C150.873 84.0083 150.984 80.8085 151.743 76.9956C153.144 69.954 157.8 65.709 162.362 63.4424C166.713 61.2805 171.341 60.6735 174.5 60.6738Z" fill="#00C0FF"/>
                        <circle cx="125.028" cy="69.3468" r="7.5" transform="rotate(45 125.028 69.3468)" fill="#0B3587"/>
                        <circle cx="243.115" cy="120.966" r="7.5" transform="rotate(45 243.115 120.966)" fill="#00C0FF"/>
                        <path d="M97.2361 90.6372L44.7171 224.852C42.175 231.349 48.5858 237.759 55.0823 235.217L189.297 182.698C194.67 180.596 196.118 173.671 192.039 169.592L110.343 87.8955C106.263 83.8161 99.3384 85.2646 97.2361 90.6372Z" fill="white"/>
                        <path d="M55.0827 235.217C48.5862 237.76 42.175 231.348 44.7171 224.852L82.684 127.826L152.108 197.251L55.0827 235.217ZM192.039 169.592C196.118 173.671 194.669 180.597 189.297 182.699L172.438 189.296L90.639 107.497L97.2356 90.6376C99.3379 85.2652 106.263 83.8163 110.343 87.8955L192.039 169.592Z" fill="#00C0FF"/>
                        </svg>

                        `,
                        'purchase_rewards': `<svg width="280" height="280" viewBox="0 0 280 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="280" height="280" fill="#F2FCFF"/>
                        <path d="M71.2127 99.1493L46.2127 199.149C43.0569 211.772 52.6041 224 65.6155 224H214.384C227.396 224 236.943 211.772 233.787 199.149L208.787 99.1493C206.561 90.2459 198.562 84 189.384 84H90.6155C81.4382 84 73.4385 90.246 71.2127 99.1493Z" fill="#00C0FF"/>
                        <path d="M140 46C99.2178 46 104.191 96 104.191 96H175.809C175.809 96 180.782 46 140 46Z" stroke="#00C0FF" stroke-width="20"/>
                        <path d="M175.809 103C175.809 103 180.782 143 140 143C99.2178 143 104.191 103 104.191 103" stroke="white" stroke-width="16" stroke-linecap="round"/>
                        <circle cx="195" cy="195" r="45" fill="#0B3587"/>
                        <path d="M193.231 166.353C193.982 164.93 196.018 164.93 196.769 166.353L204.322 180.668C204.611 181.217 205.139 181.6 205.75 181.706L221.699 184.465C223.283 184.739 223.913 186.677 222.792 187.83L211.511 199.437C211.079 199.882 210.877 200.502 210.966 201.115L213.27 217.136C213.498 218.728 211.851 219.925 210.407 219.216L195.882 212.074C195.326 211.8 194.674 211.8 194.118 212.074L179.593 219.216C178.149 219.925 176.502 218.728 176.73 217.136L179.034 201.115C179.123 200.502 178.921 199.882 178.489 199.437L167.208 187.83C166.087 186.677 166.717 184.739 168.301 184.465L184.25 181.706C184.861 181.6 185.389 181.217 185.678 180.668L193.231 166.353Z" fill="white"/>
                        </svg>

                        `,
                        'birthday_rays': `<svg width="280" height="280" viewBox="0 0 280 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="280" height="280" fill="#F2FCFF"/>
                        <g clip-path="url(#clip0_543_1687)">
                        <rect x="45" y="104" width="190" height="120" rx="20" fill="#00C0FF"/>
                        <path d="M37 144L54.4372 152.126C65.1483 157.118 77.5184 157.118 88.2295 152.126L88.7705 151.874C99.4816 146.882 111.852 146.882 122.563 151.874L123.104 152.126C133.815 157.118 146.185 157.118 156.896 152.126L157.437 151.874C168.148 146.882 180.518 146.882 191.229 151.874L191.771 152.126C202.482 157.118 214.852 157.118 225.563 152.126L243 144" stroke="white" stroke-width="20" stroke-linecap="round"/>
                        </g>
                        <rect x="130" y="57" width="20" height="55" rx="10" fill="#00C0FF"/>
                        <path d="M130.884 33.6738L139.587 20.6192C139.784 20.3246 140.216 20.3246 140.413 20.6192L149.116 33.6738C152.771 39.1569 150.794 46.6031 144.9 49.5502C141.815 51.0924 138.185 51.0924 135.1 49.5502C129.206 46.6031 127.229 39.1569 130.884 33.6738Z" fill="#0B3587"/>
                        <rect x="79" y="66" width="20" height="55" rx="10" fill="#00C0FF"/>
                        <path d="M79.8842 42.6738L88.5872 29.6192C88.7836 29.3246 89.2164 29.3246 89.4128 29.6192L98.1158 42.6738C101.771 48.1569 99.7938 55.6031 93.8996 58.5502C90.8152 60.0924 87.1848 60.0924 84.1004 58.5502C78.2062 55.6031 76.2287 48.1569 79.8842 42.6738Z" fill="#0B3587"/>
                        <rect x="181" y="66" width="20" height="55" rx="10" fill="#00C0FF"/>
                        <path d="M181.884 42.6738L190.587 29.6192C190.784 29.3246 191.216 29.3246 191.413 29.6192L200.116 42.6738C203.771 48.1569 201.794 55.6031 195.9 58.5502C192.815 60.0924 189.185 60.0924 186.1 58.5502C180.206 55.6031 178.229 48.1569 181.884 42.6738Z" fill="#0B3587"/>
                        <circle cx="195" cy="195" r="45" fill="#0B3587"/>
                        <path d="M193.231 166.353C193.982 164.93 196.018 164.93 196.769 166.353L204.322 180.668C204.611 181.217 205.139 181.6 205.75 181.706L221.699 184.465C223.283 184.739 223.913 186.677 222.792 187.83L211.511 199.437C211.079 199.882 210.877 200.502 210.966 201.115L213.27 217.136C213.498 218.728 211.851 219.925 210.407 219.216L195.882 212.074C195.326 211.8 194.674 211.8 194.118 212.074L179.593 219.216C178.149 219.925 176.502 218.728 176.73 217.136L179.034 201.115C179.123 200.502 178.921 199.882 178.489 199.437L167.208 187.83C166.087 186.677 166.717 184.739 168.301 184.465L184.25 181.706C184.861 181.6 185.389 181.217 185.678 180.668L193.231 166.353Z" fill="white"/>
                        <defs>
                        <clipPath id="clip0_543_1687">
                        <rect x="45" y="104" width="190" height="120" rx="20" fill="white"/>
                        </clipPath>
                        </defs>
                        </svg>

                        `,
                        'birthday_coupons': `<svg width="280" height="280" viewBox="0 0 280 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="280" height="280" fill="#F2FCFF"/>
                        <path d="M226.187 101.564C236.567 105.341 241.918 116.818 238.141 127.198L228.564 153.509C222.336 151.243 215.45 154.454 213.183 160.681C210.917 166.909 214.128 173.795 220.355 176.062L210.779 202.373C207.001 212.753 195.524 218.105 185.145 214.327L34.7939 159.604C24.4143 155.826 19.0626 144.349 22.8404 133.969L32.417 107.658C38.6447 109.925 45.5308 106.714 47.7975 100.486C50.0642 94.2581 46.8532 87.372 40.6255 85.1052L50.202 58.7939C53.9799 48.4143 65.4567 43.0626 75.8363 46.8404L226.187 101.564Z" fill="#0B3587"/>
                        <path d="M220 120C231.046 120 240 128.954 240 140V168C233.373 168 228 173.373 228 180C228 186.627 233.373 192 240 192V220C240 231.046 231.046 240 220 240H60C48.9543 240 40 231.046 40 220V192C46.6274 192 52 186.627 52 180C52 173.373 46.6274 168 40 168V140C40 128.954 48.9543 120 60 120H220Z" fill="#00C0FF"/>
                        <path d="M114.6 190.04C104.36 190.04 96.44 182.44 96.44 173.24C96.44 163.96 104.36 156.44 114.6 156.44C124.84 156.44 132.76 163.96 132.76 173.24C132.76 182.44 124.84 190.04 114.6 190.04ZM129.48 211H118.68L149.56 156.92H160.36L129.48 211ZM114.6 180.36C118.36 180.36 121.64 178.12 121.64 173.24C121.64 168.36 118.36 166.12 114.6 166.12C110.92 166.12 107.48 168.36 107.48 173.24C107.48 178.12 110.92 180.36 114.6 180.36ZM166.12 211.72C155.88 211.72 147.96 204.12 147.96 194.92C147.96 185.64 155.88 178.12 166.12 178.12C176.36 178.12 184.28 185.64 184.28 194.92C184.28 204.12 176.36 211.72 166.12 211.72ZM166.12 202.04C169.88 202.04 173.16 199.8 173.16 194.92C173.16 190.04 169.88 187.8 166.12 187.8C162.44 187.8 159 190.04 159 194.92C159 199.8 162.44 202.04 166.12 202.04Z" fill="white"/>
                        </svg>


                        `,
                        'birthday_gift': `<svg width="280" height="280" viewBox="0 0 280 280" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="280" height="280" fill="#F2FCFF"/>
                            <g clip-path="url(#clip0_543_1717)">
                            <rect x="45" y="104" width="190" height="120" rx="20" fill="#00C0FF"/>
                            <path d="M37 144L54.4372 152.126C65.1483 157.118 77.5184 157.118 88.2295 152.126L88.7705 151.874C99.4816 146.882 111.852 146.882 122.563 151.874L123.104 152.126C133.815 157.118 146.185 157.118 156.896 152.126L157.437 151.874C168.148 146.882 180.518 146.882 191.229 151.874L191.771 152.126C202.482 157.118 214.852 157.118 225.563 152.126L243 144" stroke="white" stroke-width="20" stroke-linecap="round"/>
                            </g>
                            <rect x="130" y="57" width="20" height="55" rx="10" fill="#00C0FF"/>
                            <path d="M130.884 33.6738L139.587 20.6192C139.784 20.3246 140.216 20.3246 140.413 20.6192L149.116 33.6738C152.771 39.1569 150.794 46.6031 144.9 49.5502C141.815 51.0924 138.185 51.0924 135.1 49.5502C129.206 46.6031 127.229 39.1569 130.884 33.6738Z" fill="#0B3587"/>
                            <rect x="79" y="66" width="20" height="55" rx="10" fill="#00C0FF"/>
                            <path d="M79.8842 42.6738L88.5872 29.6192C88.7836 29.3246 89.2164 29.3246 89.4128 29.6192L98.1158 42.6738C101.771 48.1569 99.7938 55.6031 93.8996 58.5502C90.8152 60.0924 87.1848 60.0924 84.1004 58.5502C78.2062 55.6031 76.2287 48.1569 79.8842 42.6738Z" fill="#0B3587"/>
                            <rect x="181" y="66" width="20" height="55" rx="10" fill="#00C0FF"/>
                            <path d="M181.884 42.6738L190.587 29.6192C190.784 29.3246 191.216 29.3246 191.413 29.6192L200.116 42.6738C203.771 48.1569 201.794 55.6031 195.9 58.5502C192.815 60.0924 189.185 60.0924 186.1 58.5502C180.206 55.6031 178.229 48.1569 181.884 42.6738Z" fill="#0B3587"/>
                            <rect x="163" y="176" width="76" height="64" rx="8" fill="#0B3587"/>
                            <rect x="195" y="175" width="12" height="65" fill="#00C0FF"/>
                            <path d="M187 163.196C185.343 160.327 186.326 156.657 189.196 155C192.066 153.343 195.735 154.327 197.392 157.196L205.392 171.053C207.049 173.923 206.066 177.592 203.196 179.249C200.326 180.906 196.657 179.923 195 177.053L187 163.196Z" fill="#0B3587"/>
                            <path d="M215.392 163.196C217.049 160.327 216.066 156.657 213.196 155C210.326 153.343 206.657 154.327 205 157.196L197 171.053C195.343 173.923 196.326 177.592 199.196 179.249C202.066 180.906 205.735 179.923 207.392 177.053L215.392 163.196Z" fill="#0B3587"/>
                            <defs>
                            <clipPath id="clip0_543_1717">
                            <rect x="45" y="104" width="190" height="120" rx="20" fill="white"/>
                            </clipPath>
                            </defs>
                            </svg>


                        `
            }

            // 初始化多语言消息配置（需要在提前返回之前初始化）
            this.enEGMessageg = {
                EG1: {
                    benefits: [
                        {
                            title: "Welcome Offer",
                            description: "6% OFF Coupon",
                            icon: benefitsIcon.first_order_offer
                        },
                        {
                            title: "Purchase Rewards", 
                            description: "$1 Spent = 10 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Birthday Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        }
                    ]
                },
                EG2: {
                    benefits: [
                        {
                            title: "Purchase Rewards",
                            description: "$1 Spent = 10 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Birthday Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Birthday Coupons",
                            description: "$5 OFF Coupon with No Threshold",
                            icon: benefitsIcon.birthday_coupons
                        }
                    ]
                },
                EG3: {
                    benefits: [
                        {
                            title: "Purchase Rewards",
                            description: "$1 Spent = 12 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Birthday Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Birthday Coupons",
                            description: "$5 + 5% OFF Coupons with No Threshold",
                            icon: benefitsIcon.birthday_coupons
                        }
                    ]
                },
                EG4: {
                    benefits: [
                        {
                            title: "Purchase Rewards",
                            description: "$1 Spent = 15 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Birthday Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Birthday Coupons",
                            description: "$5 + 5% OFF Coupons with No Threshold",
                            icon: benefitsIcon.birthday_coupons
                        },
                        {
                            title: "Birthday Gift",
                            description: "Special gift exclusively for you",
                            icon: benefitsIcon.birthday_gift
                        }
                    ]
                }
            };

            // 德语版本
            this.deEGMessageg = {
                EG1: {
                    benefits: [
                        {
                            title: "Willkommensangebot",
                            description: "5% Rabatt Gutschein",
                            icon: benefitsIcon.first_order_offer
                        },
                        {
                            title: "Einkaufs Belohnungen", 
                            description: "$1 Ausgegeben = 10 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Geburtstags Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        }
                    ]
                },
                EG2: {
                    benefits: [
                        {
                            title: "Einkaufs Belohnungen",
                            description: "$1 Ausgegeben = 10 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Geburtstags Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Geburtstags Gutscheine",
                            description: "$5 Rabatt Gutschein ohne Mindestbestellwert",
                            icon: benefitsIcon.birthday_coupons
                        }
                    ]
                },
                EG3: {
                    benefits: [
                        {
                            title: "Einkaufs Belohnungen",
                            description: "$1 Ausgegeben = 12 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Geburtstags Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Geburtstags Gutscheine",
                            description: "$5 + 5% Rabatt Gutscheine ohne Mindestbestellwert",
                            icon: benefitsIcon.birthday_coupons
                        }
                    ]
                },
                EG4: {
                    benefits: [
                        {
                            title: "Einkaufs Belohnungen",
                            description: "$1 Ausgegeben = 15 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Geburtstags Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Geburtstags Gutscheine",
                            description: "$5 + 5% Rabatt Gutscheine ohne Mindestbestellwert",
                            icon: benefitsIcon.birthday_coupons
                        },
                        {
                            title: "Geburtstags Geschenk",
                            description: "Spezielles Geschenk exklusiv für Sie",
                            icon: benefitsIcon.birthday_gift
                        }
                    ]
                }
            };

            // 日语版本
            this.jaEGMessageg = {
                EG1: {
                    benefits: [
                        {
                            title: "ウェルカムオファー",
                            description: "5%オフクーポン",
                            icon: benefitsIcon.first_order_offer
                        },
                        {
                            title: "購入報酬", 
                            description: "￥100の支出 = 10 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "誕生日Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        }
                    ]
                },
                EG2: {
                    benefits: [
                        {
                            title: "購入報酬",
                            description: "￥100の支出 = 10 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "誕生日Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "誕生日クーポン",
                            description: "最低購入金額なし$5オフクーポン",
                            icon: benefitsIcon.birthday_coupons
                        }
                    ]
                },
                EG3: {
                    benefits: [
                        {
                            title: "購入報酬",
                            description: "￥100の支出 = 12 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "誕生日Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "誕生日クーポン",
                            description: "最低購入金額なし$5 + 5%オフクーポン",
                            icon: benefitsIcon.birthday_coupons
                        }
                    ]
                },
                EG4: {
                    benefits: [
                        {
                            title: "購入報酬",
                            description: "￥100の支出 = 15 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "誕生日Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "誕生日クーポン",
                            description: "最低購入金額なし$5 + 5%オフクーポン",
                            icon: benefitsIcon.birthday_coupons
                        },
                        {
                            title: "誕生日ギフト",
                            description: "あなた専用の特別ギフト",
                            icon: benefitsIcon.birthday_gift
                        }
                    ]
                }
            };

            // 法语版本
            this.frEGMessageg = {
                EG1: {
                    benefits: [
                        {
                            title: "Offre de bienvenue",
                            description: "Coupon de réduction de 5%",
                            icon: benefitsIcon.first_order_offer
                        },
                        {
                            title: "Récompenses d'Achat", 
                            description: "$1 dépensé = 10 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Rays d'Anniversaire",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        }
                    ]
                },
                EG2: {
                    benefits: [
                        {
                            title: "Récompenses d'Achat",
                            description: "$1 dépensé = 10 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Rays d'Anniversaire",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Coupons d'Anniversaire",
                            description: "Coupon de $5 sans minimum d'achat",
                            icon: benefitsIcon.birthday_coupons
                        }
                    ]
                },
                EG3: {
                    benefits: [
                        {
                            title: "Récompenses d'Achat",
                            description: "$1 dépensé = 12 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Rays d'Anniversaire",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Coupons d'Anniversaire",
                            description: "Coupons de $5 + 5% sans minimum d'achat",
                            icon: benefitsIcon.birthday_coupons
                        }
                    ]
                },
                EG4: {
                    benefits: [
                        {
                            title: "Récompenses d'Achat",
                            description: "$1 dépensé = 15 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Rays d'Anniversaire",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Coupons d'Anniversaire",
                            description: "Coupons de $5 + 5% sans minimum d'achat",
                            icon: benefitsIcon.birthday_coupons
                        },
                        {
                            title: "Cadeau d'Anniversaire",
                            description: "Cadeau spécial exclusivement pour vous",
                            icon: benefitsIcon.birthday_gift
                        }
                    ]
                }
            };

            // 荷兰语版本
            this.nlEGMessageg = {
                EG1: {
                    benefits: [
                        {
                            title: "Welkomstaanbieding",
                            description: "5% Kortingsbon",
                            icon: benefitsIcon.first_order_offer
                        },
                        {
                            title: "Aankoop Beloningen", 
                            description: "$1 uitgegeven = 10 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Verjaardag Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        }
                    ]
                },
                EG2: {
                    benefits: [
                        {
                            title: "Aankoop Beloningen",
                            description: "$1 uitgegeven = 10 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Verjaardag Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Verjaardag Kortingsbonnen",
                            description: "$5 Kortingsbon zonder minimum",
                            icon: benefitsIcon.birthday_coupons
                        }
                    ]
                },
                EG3: {
                    benefits: [
                        {
                            title: "Aankoop Beloningen",
                            description: "$1 uitgegeven = 12 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Verjaardag Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Verjaardag Kortingsbonnen",
                            description: "$5 + 5% Kortingsbonnen zonder minimum",
                            icon: benefitsIcon.birthday_coupons
                        }
                    ]
                },
                EG4: {
                    benefits: [
                        {
                            title: "Aankoop Beloningen",
                            description: "$1 uitgegeven = 15 Renogy Rays",
                            icon: benefitsIcon.purchase_rewards
                        },
                        {
                            title: "Verjaardag Rays",
                            description: "50 Rays",
                            icon: benefitsIcon.birthday_rays
                        },
                        {
                            title: "Verjaardag Kortingsbonnen",
                            description: "$5 + 5% Kortingsbonnen zonder minimum",
                            icon: benefitsIcon.birthday_coupons
                        },
                        {
                            title: "Verjaardag Cadeau",
                            description: "Speciaal cadeau exclusief voor jou",
                            icon: benefitsIcon.birthday_gift
                        }
                    ]
                }
            };

            // 多语言文本配置
            this.enMessages = {
                congratulations: 'Congratulations! L4 enjoy exclusive...',
                highestLevel: 'You have reached the highest level!',
                raysNeeded: 'Rays Needed to Reach',
                levelMessages: {
                    'L1': 'Earn more L1 Rays and upgrade to L2 to enjoy more exclusive rewards.',
                    'L2': 'Earn more L2 Rays and upgrade to L3 to enjoy more exclusive rewards.',
                    'L3': 'Earn more L3 Rays and upgrade to L4 to enjoy more exclusive rewards.',
                    'L4': 'Congratulations! You have reached the highest level and enjoy all exclusive rewards.'
                },
                expandButton: {
                    viewMore: 'View',
                    moreBenefits: 'More Benefits',
                    collapse: 'Collapse'
                },
                couponInfo: {
                    out_of_stock: 'Out Of Stock',
                    coupon_text:"Min. Spend",
                    available: 'Available',
                    usage_rules: 'Usage Rules',
                    redeem_text: 'Redeem With',
                    redeem:'Redeem',
                    rays: 'Rays',
                    valid_until: "Valid Until",
                    redeem_copy:"Copy and Use",
                    gift_card_code: 'Gift Card Code:',
                    check_email: 'Check Your Email',
                    free:"Free",
                    code:"Code",
                    coupon:"Coupon",
                },
            };

            this.deMessages = {
                congratulations: 'Herzlichen Glückwunsch! L4 genießen exklusive...',
                highestLevel: 'Sie haben das höchste Level erreicht!',
                raysNeeded: 'Rays benötigt um zu erreichen',
                levelMessages: {
                    'L1': 'Verdienen Sie mehr L1 Rays und steigen Sie auf L2 auf, um mehr exklusive Belohnungen zu genießen.',
                    'L2': 'Verdienen Sie mehr L2 Rays und steigen Sie auf L3 auf, um mehr exklusive Belohnungen zu genießen.',
                    'L3': 'Verdienen Sie mehr L3 Rays und steigen Sie auf L4 auf, um mehr exklusive Belohnungen zu genießen.',
                    'L4': 'Herzlichen Glückwunsch! Sie haben das höchste Level erreicht und genießen alle exklusiven Belohnungen.'
                },
                expandButton: {
                    viewMore: 'Zeige',
                    moreBenefits: 'Weitere Vorteile',
                    collapse: 'Einklappen'
                },
                couponInfo: {
                    out_of_stock: 'Nicht vorrätig',
                    coupon_text: 'Mindestbestellwert',
                    available: 'Verfügbar',
                    usage_rules: 'Verwendungsregeln',
                    redeem_text: 'Einlösen mit',
                    redeem:'Einlösen',
                    rays: 'Rays',
                    valid_until: 'Gültig bis',
                    redeem_copy:"Kopieren und Verwenden",
                    gift_card_code: 'Geschenkkartencode:',
                    check_email: 'Überprüfen Sie Ihre E-Mail',
                    free:"Kostenlos",
                    code:"Code",
                    coupon:"Gutschein",
                }
            };

            this.jaMessages = {
                congratulations: 'おめでとうございます！L4は限定特典をお楽しみください...',
                highestLevel: '最高レベルに達しました！',
                raysNeeded: 'に到達するために必要なRays',
                levelMessages: {
                    'L1': 'より多くのL1 Raysを獲得してL2にアップグレードし、より多くの限定特典をお楽しみください。',
                    'L2': 'より多くのL2 Raysを獲得してL3にアップグレードし、より多くの限定特典をお楽しみください。',
                    'L3': 'より多くのL3 Raysを獲得してL4にアップグレードし、より多くの限定特典をお楽しみください。',
                    'L4': 'おめでとうございます！最高レベルに達し、すべての限定特典をお楽しみいただけます。'
                },
                expandButton: {
                    viewMore: '表示',
                    moreBenefits: 'その他の特典',
                    collapse: '折りたたむ'
                },
                couponInfo: {
                    out_of_stock: '在庫切れ',
                    coupon_text: '以上の注文',
                    available: '利用可能',
                    usage_rules: '利用規則',
                    redeem_text: 'で交換',
                    redeem:'redeem',
                    rays: 'Rays',
                    valid_until: '有効期限',
                    redeem_copy:"コピーして使用",
                    gift_card_code: 'ギフトカードコード：',
                    check_email: 'メールを確認',
                    free:"無料",
                    code:"コード",
                    coupon:"クーポン",
                }

            };

            this.frMessages = {
                congratulations: 'Félicitations ! L4 profitent d\'exclusivités...',
                highestLevel: 'Vous avez atteint le niveau le plus élevé !',
                raysNeeded: 'Rays nécessaires pour atteindre',
                levelMessages: {
                    'L1': 'Gagnez plus de L1 Rays et passez au L2 pour profiter de plus de récompenses exclusives.',
                    'L2': 'Gagnez plus de L2 Rays et passez au L3 pour profiter de plus de récompenses exclusives.',
                    'L3': 'Gagnez plus de L3 Rays et passez au L4 pour profiter de plus de récompenses exclusives.',
                    'L4': 'Félicitations ! Vous avez atteint le niveau le plus élevé et profitez de toutes les récompenses exclusives.'
                },
                expandButton: {
                    viewMore: 'Voir',
                    moreBenefits: 'Plus d\'avantages',
                    collapse: 'Réduire'
                },
                couponInfo: {
                    out_of_stock: 'En rupture de stock',
                    coupon_text: "Dès",
                    available: 'Disponible',
                    usage_rules: 'Règles d\'utilisation',
                    redeem_text: 'Utiliser avec',
                    redeem:'Utiliser',
                    rays: 'Rays',
                    valid_until: "Valable jusqu'au",
                    redeem_copy:"Copier et utiliser",
                    gift_card_code: 'Code de carte cadeau :',
                    check_email: 'Vérifiez vos emails',
                    free:"Gratuit",
                    code:"Code",
                    coupon:"Coupon",
                }
            };

            this.nlMessages = {
                congratulations: 'Gefeliciteerd! L4 geniet van exclusieve...',
                highestLevel: 'Je hebt het hoogste niveau bereikt!',
                raysNeeded: 'Rays nodig om te bereiken',
                levelMessages: {
                    'L1': 'Verdien meer L1 Rays en upgrade naar L2 om meer exclusieve beloningen te genieten.',
                    'L2': 'Verdien meer L2 Rays en upgrade naar L3 om meer exclusieve beloningen te genieten.',
                    'L3': 'Verdien meer L3 Rays en upgrade naar L4 om meer exclusieve beloningen te genieten.',
                    'L4': 'Gefeliciteerd! Je hebt het hoogste niveau bereikt en geniet van alle exclusieve beloningen.'
                },
                expandButton: {
                    viewMore: 'Bekijk',
                    moreBenefits: 'Meer voordelen',
                    collapse: 'Inklappen'
                },
                couponInfo: {
                    out_of_stock: 'Niet op voorraad',
                    coupon_text: 'Min. besteding',
                    available: 'Beschikbaar',
                    usage_rules: 'Gebruiksregels',
                    redeem_text: 'Inwisselen met',
                    redeem:'Inwisselen',
                    rays: 'Rays',
                    valid_until: 'Geldig tot',
                    redeem_copy:"Kopiëren en gebruiken",
                    gift_card_code: 'Cadeauboncode:',
                    check_email: 'Controleer uw e-mail',
                    free:"Gratis",
                    code:"Code",
                    coupon:"Coupon",
                },
            };

            this.esMessages = {
                congratulations: '¡Felicidades! L4 disfruta de recompensas exclusivas...',
                highestLevel: '¡Has alcanzado el nivel más alto!',
                raysNeeded: 'Rays necesarios para alcanzar',
                levelMessages: {
                    'L1': 'Gana más L1 Rays y actualiza a L2 para disfrutar de más recompensas exclusivas.',
                    'L2': 'Gana más L2 Rays y actualiza a L3 para disfrutar de más recompensas exclusivas.',
                    'L3': 'Gana más L3 Rays y actualiza a L4 para disfrutar de más recompensas exclusivas.',
                    'L4': '¡Felicidades! Has alcanzado el nivel más alto y disfrutas de todas las recompensas exclusivas.'
                },
                expandButton: {
                    viewMore: 'Ver',
                    moreBenefits: 'Más beneficios',
                    collapse: 'Colapsar'
                },
                couponInfo: {
                    out_of_stock: 'Agotado',
                    coupon_text: "Compra mín.",
                    available: 'Disponible',
                    usage_rules: 'Reglas de uso',
                    redeem_text: 'Canjear con',
                    redeem:'Canjear',
                    rays: 'Rays',
                    valid_until: "Válido hasta",
                    redeem_copy:"Copiar y usar",
                    gift_card_code: 'Código de tarjeta regalo:',
                    check_email: 'Revisa tu correo electrónico',
                    free:"Gratis",
                    code:"Código",
                    coupon:"Cupón",
                },
            };

            this.plMessages = {
                congratulations: 'Gratulacje! L4 ciesz się ekskluzywnymi nagrodami...',
                highestLevel: 'Osiągnąłeś najwyższy poziom!',
                raysNeeded: 'Rays potrzebne do osiągnięcia',
                levelMessages: {
                    'L1': 'Zdobądź więcej L1 Rays i awansuj do L2, aby cieszyć się większą liczbą ekskluzywnych nagród.',
                    'L2': 'Zdobądź więcej L2 Rays i awansuj do L3, aby cieszyć się większą liczbą ekskluzywnych nagród.',
                    'L3': 'Zdobądź więcej L3 Rays i awansuj do L4, aby cieszyć się większą liczbą ekskluzywnych nagród.',
                    'L4': 'Gratulacje! Osiągnąłeś najwyższy poziom i korzystasz ze wszystkich ekskluzywnych nagród.'
                },
                expandButton: {
                    viewMore: 'Zobacz',
                    moreBenefits: 'Więcej korzyści',
                    collapse: 'Zwiń'
                },
                couponInfo: {
                    out_of_stock: 'Wyprzedane',
                    coupon_text: 'Min. zakup',
                    available: 'Dostępne',
                    usage_rules: 'Zasady użytkowania',
                    redeem_text: 'Zrealizuj za',
                    redeem: 'Zrealizuj',
                    rays: 'Rays',
                    valid_until: 'Ważne do',
                    redeem_copy: 'Kopiuj i użyj',
                    gift_card_code: 'Kod karty podarunkowej:',
                    check_email: 'Sprawdź swoją skrzynkę e-mail',
                    free: 'Gratis',
                    code: 'Kod',
                    coupon: 'Kupon',
                },
            };

            this.itMessages = {
                congratulations: 'Congratulazioni! L4 goditi vantaggi esclusivi...',
                highestLevel: 'Hai raggiunto il livello più alto!',
                raysNeeded: 'Rays necessari per raggiungere',
                levelMessages: {
                    'L1': 'Guadagna più L1 Rays e passa al livello L2 per godere di più ricompense esclusive.',
                    'L2': 'Guadagna più L2 Rays e passa al livello L3 per godere di più ricompense esclusive.',
                    'L3': 'Guadagna più L3 Rays e passa al livello L4 per godere di più ricompense esclusive.',
                    'L4': 'Congratulazioni! Hai raggiunto il livello più alto e godi di tutte le ricompense esclusive.'
                },
                expandButton: {
                    viewMore: 'Visualizza',
                    moreBenefits: 'Altri vantaggi',
                    collapse: 'Comprimi'
                },
                couponInfo: {
                    out_of_stock: 'Esaurito',
                    coupon_text: "Spesa min.",
                    available: 'Disponibile',
                    usage_rules: 'Regole di utilizzo',
                    redeem_text: 'Riscatta con',
                    redeem:'Riscatta',
                    rays: 'Rays',
                    valid_until: "Valido fino a",
                    redeem_copy:"Copia e usa",
                    gift_card_code: 'Codice della carta regalo:',
                    check_email: 'Controlla la tua email',
                    free:"Gratis",
                    code:"Codice",
                    coupon:"Coupon",
                },
            };

            // 根据语言选择对应版本
            const locale = window.Shopify?.locale || 'en';
            switch (locale.toLowerCase()) {
                case 'de':
                    this.EGMessageg = this.deEGMessageg;
                    this.messages = this.deMessages;
                    break;
                case 'ja':
                    this.EGMessageg = this.jaEGMessageg;
                    this.messages = this.jaMessages;
                    break;
                case 'fr':
                    this.EGMessageg = this.frEGMessageg;
                    this.messages = this.frMessages;
                    break;
                case 'nl':
                    this.EGMessageg = this.nlEGMessageg;
                    this.messages = this.nlMessages;
                    break;
                case 'es':
                    this.EGMessageg = this.enEGMessageg;
                    this.messages = this.esMessages;
                    break;
                case 'pl':
                    this.EGMessageg = this.enEGMessageg;
                    this.messages = this.plMessages;
                    break;
                case 'it':
                    this.EGMessageg = this.enEGMessageg;
                    this.messages = this.itMessages;
                    break;
                default:
                    this.EGMessageg = this.enEGMessageg;
                    this.messages = this.enMessages;
                    break;
            }
            UserLoginStatus.instance = this;
        }

        refreshContainers() {
            this.userLoginSectionContainer = document.querySelector('[user-login-section-container]');
            this.memberContentContainers = document.querySelectorAll('[member-content-container]');
            this.memberAssetsContainers = document.querySelectorAll('[user-login-cta-container]');
            this.memberCouponContainers = document.querySelectorAll('[member-coupon-container]');
            this.giftCardCouponContainers = document.querySelectorAll('[gift-card-coupon-container]');
            this.productCardCouponContainers = document.querySelectorAll('[product-card-coupon-container]');
        }

        async init() {
            this.refreshContainers();
            
            if(window.renogyConfig  && !window.renogyConfig.user_email){
                this.clearCookies();
            }
            if (this.userLoginSectionContainer && this.accessToken && this.refreshToken) {
                try {
                    await this.getMerberData();
                } catch(error) {
                    // console.log(error);
                }
                this.renderAccountCard();
                this.initBenefitsExpand();
            }



            if (this.memberContentContainers.length > 0) {
                if (this.accessToken && this.refreshToken) {
                    await this.getSubscribeData();
                }
                this.renderMemberContent();
            }
            if (this.memberAssetsContainers.length > 0) {
                if (this.accessToken && this.refreshToken) {
                    await this.getMemberCenterProfile();
                    await this.getMemberCenterAssets();
                }
            }
            try {
                await this.getMerberData();
            } catch(error) {
                // console.log(error);
            }
            const couponDataRequests = [];
            if (this.memberCouponContainers.length > 0) {
                couponDataRequests.push(this.getCouponData());
            }

            if(this.giftCardCouponContainers.length > 0){
                couponDataRequests.push(this.getGiftCardCouponData());
            }
            if(this.productCardCouponContainers.length > 0){
                couponDataRequests.push(this.getProductCardCouponData());
            }
            await Promise.allSettled(couponDataRequests);

            // 初始化 Tooltip 功能
            this.initTooltips();
        }


        getSubscribeData() {
            // 获取用户订阅邮箱信息
            return this._request('/get_user_subscribe_email_info?storeId=' + this.storeId)
                .then(resp => {
                    if (resp.code === "000000") {
                        if (window.location.hostname === '127.0.0.1') {
                            this.subscribeEmailInfo = true;
                        } else {
                        this.subscribeEmailInfo = resp.data?.isSubscribeEmail;
                    }
                    }
                    return resp;
                })
                .catch(error => {
                    throw error;
                });
        }
        renderMemberContent() {
            this.memberContentContainers.forEach(container => {
                if (this.subscribeEmailInfo) {
                    const subscribeElement = container.querySelector('[data-membership-task-type="subscribe"]');
                    if (subscribeElement) {
                        subscribeElement.classList.add('rg-active');
                    }
                }

                container.querySelectorAll('a[href^="#"]').forEach(item => {
                    item.addEventListener('click', (e) => {
                        e.preventDefault();
                        
                        const href = item.getAttribute('href');
                        const targetId = href.substring(1);
                        const targetElement = document.getElementById(targetId);
                        
                        if (targetElement) {
                            targetElement.scrollIntoView({
                                behavior: 'smooth',
                                block: 'start'
                            });
                        }
                    });
                });
            });
        }
        getCouponData() {
            // 获取页面优惠券模板信息
            const apiPath = `/page_coupon_template?exchangeChannelList=0&exchangeChannelList=2&appliesToEntity=categories&usePlatformId=${this.storeId}&pageSize=32&pageNum=1`;

            if (this.pageCouponTemplateData) {
                this.renderMemberCoupon();
                return Promise.resolve(this.pageCouponTemplateData);
            }

            if (this.couponDataPromise) {
                return this.couponDataPromise.then(resp => {
                    this.renderMemberCoupon();
                    return resp;
                });
            }

            this.couponDataPromise = this._request(apiPath, { requireAuth: false, includeToken: false })
                .then(resp => {
                    if (resp && resp.code === "000000") {
                        this.pageCouponTemplateData = resp.data;
                        this.renderMemberCoupon();
                    }
                    return resp;
                })
                .catch(error => {
                    throw error;
                })
                .finally(() => {
                    this.couponDataPromise = null;
                });

            return this.couponDataPromise;
        }
        getGiftCardCouponData(){
            // 获取页面优惠券模板信息
            const apiPath = `/page_gift_card_template?exchangeChannelList=0&exchangeChannelList=2&usePlatformId=${this.storeId}&pageSize=32&pageNum=1`;

            if (this.giftCardCouponData) {
                this.renderGiftCardCoupon();
                return Promise.resolve(this.giftCardCouponData);
            }

            if (this.giftCardCouponDataPromise) {
                return this.giftCardCouponDataPromise.then(resp => {
                    this.renderGiftCardCoupon();
                    return resp;
                });
            }

            this.giftCardCouponDataPromise = this._request(apiPath, { requireAuth: false, includeToken: false })
            .then(resp => {
                if (resp && resp.code === "000000") {
                    this.giftCardCouponData = resp.data;
                    this.renderGiftCardCoupon();
                }
                return resp;
            })
            .catch(error => {
                throw error;
            })
            .finally(() => {
                this.giftCardCouponDataPromise = null;
            });

            return this.giftCardCouponDataPromise;
        }
        getProductCardCouponData(){
            // 获取页面优惠券模板信息
            const apiPath = `/page_coupon_template?exchangeChannelList=0&exchangeChannelList=2&appliesToEntity=products&isNeedCouponTemplateProduct=1&usePlatformId=${this.storeId}&pageSize=32&pageNum=1`;

            if (this.productCardCouponData) {
                this.renderProductCardCoupon();
                return Promise.resolve(this.productCardCouponData);
            }

            if (this.productCardCouponDataPromise) {
                return this.productCardCouponDataPromise.then(resp => {
                    this.renderProductCardCoupon();
                    return resp;
                });
            }

            this.productCardCouponDataPromise = this._request(apiPath, { requireAuth: false, includeToken: false })
            .then(resp => {
                if (resp && resp.code === "000000") {
                    this.productCardCouponData = resp.data;
                    this.renderProductCardCoupon();
                }
                return resp;
            })
            .catch(error => {
                throw error;
            })
            .finally(() => {
                this.productCardCouponDataPromise = null;
            });

            return this.productCardCouponDataPromise;
        }
        deleteRecordIdData(){
            const url = this.apiUrl+`/api/coupon/delete-record`;
            try {
                fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Token": this.accessToken
                    },
                    body: JSON.stringify({recordId: this.recordId,email:this.customerEmail}),
                })
            } catch(error) {
                throw error;
            }
        }
        async checkCouponLimit(couponInfo){
            const url = this.apiUrl+`/api/coupon/check-limit`;
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Token": this.accessToken
                    },
                    body: JSON.stringify(couponInfo),
                });
                const data = await res.json();
                // 判断返回的code值
                if (data.code !== 200) { 
                    this.isRedeem = false;
                }
                this.recordId = data.data?.recordId || '';
            } catch(error) {
                this.isRedeem = false;
            }
        }
        couponExpiresHandler(coupon) {
            const createDate = coupon.createDate;
            const couponExpires = coupon.couponExpires || coupon.giftCardExpires;
            let startDate = new Date(createDate);
            let couponExpiresNew = Number(couponExpires);
        
            if (isNaN(startDate.getTime())) {
                throw new Error('无效的开始时间格式');
            }
            
            const tenDaysInMs = couponExpiresNew * 24 * 60 * 60 * 1000;
            const resultDate = new Date(startDate.getTime() + tenDaysInMs);
            const resultDateYear = resultDate.getFullYear();
            const resultDateMonth = (resultDate.getMonth() + 1) > 9 ? `${resultDate.getMonth() + 1}` : `0${resultDate.getMonth() + 1}`;
            const resultDateDay = resultDate.getDate() > 9 ? `${resultDate.getDate()}` : `0${resultDate.getDate()}`;
            return resultDateYear + '-' + resultDateMonth + '-' + resultDateDay ;
        }
        async redeemCoupon(couponId,memberCouponContainer){
            
            const couponInfo = this.pageCouponTemplateData.contentList.find(item => item.couponTemplateId == couponId);
            const couponLimitInfo = {
                email:this.customerEmail,
                type:'coupon',
                limitCount:Number(window.customerSetting.coupon.limitCount),
                limitDay:Number(window.customerSetting.coupon.limitDay)
            }
            await this.checkCouponLimit(couponLimitInfo);
            if(!this.isRedeem){ 
                this.renderToast(this.toastTipsIcon,window.customerSetting.coupon.not_enough_times_text);
                return ;
            }
            if(couponInfo.stock > 0 && this.isRedeem){
                const membershipCouponDialogFirst = memberCouponContainer.querySelector(".membership-coupon-dialog-content-first");
                const membershipCouponDialogSuccess = memberCouponContainer.querySelector(".membership-coupon-dialog-content-success");
                const rays_numer = membershipCouponDialogFirst.querySelector('.rays-number');
                rays_numer.innerHTML = couponInfo.redeemBonusPoint;
                let closeBtnHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                    <rect x="1" y="1" width="24" height="24" rx="12" fill="white" fill-opacity="0.3"/>
                    <rect x="6.33295" y="18.4546" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-45 6.33295 18.4546)" fill="#1C1C1C"/>
                    <rect x="18.4548" y="19.667" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-135 18.4548 19.667)" fill="#1C1C1C"/>
                </svg>`;
                
                // 克隆元素以避免修改原始DOM
                const firstDialogClone = membershipCouponDialogFirst.cloneNode(true);
                firstDialogClone.style.display = 'block';
                
                Swal.fire({
                    showCloseButton: true,
                    showCancelButton: true,
                    showConfirmButton: true,
                    html: firstDialogClone,
                    closeButtonHtml: closeBtnHtml,
                    confirmButtonText: "Redeem",
                    cancelButtonText: "Cancel",
                    customClass: {
                        container: "membership-coupon-popup-container",
                        popup: "membership-coupon-popup",
                    },
                
                }).then((result) => {
                    if(result.isConfirmed){
                        const modal_html = `<div class="is-loading"></div>`;
                        Swal.fire({
                            html: modal_html,
                            showCloseButton: false,
                            showCancelButton: false,
                            showConfirmButton: false,
                            customClass: {
                                container: "membership-coupon-popup-container",
                                popup: "membership-coupon-popup",
                            },
                        });
                        this.exchangeCoupon(couponInfo.couponTemplateId).then(resp => {
                            if(resp.code === "000000"){
                                couponInfo.couponCode = resp.data.couponCode;
                                this.confirmRedeemCoupon(membershipCouponDialogSuccess.cloneNode(true), couponInfo, closeBtnHtml,memberCouponContainer);
                            }else{
                                this.deleteRecordIdData();
                                Swal.fire(
                                    {
                                        toast: true,
                                        position: 'center',
                                        title: resp.msg,
                                        customClass: {
                                        popup: 'custom-error-toast',
                                        container: 'custom-error-toast-container',
                                        },
                                        iconHtml:this.toastErrorIcon,
                                        showConfirmButton: false,
                                        timer: 6000,
                                    }
                                )
                            }
                        }).catch(err=>{
                            this.deleteRecordIdData();
                            if(err.message.includes('accessToken')){
                                const loginHref = sessionStorage.getItem("loginHref")
                                window.location.href = loginHref;
                            }else{
                                Swal.close();
                            }
                        })
                    }else{
                        this.deleteRecordIdData();
                    }
                });
            }
        }
        async redeemGiftCardCoupon(couponId,giftCardCouponContainer){
            const couponInfo = this.giftCardCouponData.giftCardTemplateContents.find(item => item.giftCardTemplateId == couponId);
            const couponLimitInfo = {
                email:this.customerEmail,
                type:'gift_card',
                limitCount:Number(window.customerSetting.gift_card.limitCount),
                limitDay:Number(window.customerSetting.gift_card.limitDay)
            }
            await this.checkCouponLimit(couponLimitInfo);
            if(!this.isRedeem){ 
                this.renderToast(this.toastTipsIcon,window.customerSetting.gift_card.not_enough_times_text);
                return ;
            }
            if(couponInfo.stock > 0 && this.isRedeem){
                const membershipCouponDialogFirst = giftCardCouponContainer.querySelector(".membership-coupon-dialog-content-first");
                const membershipCouponDialogSuccess = giftCardCouponContainer.querySelector(".membership-coupon-dialog-content-success");
                const rays_numer = membershipCouponDialogFirst.querySelector('.rays-number');
                rays_numer.innerHTML = couponInfo.redeemBonusPoint;
                let closeBtnHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                    <rect x="1" y="1" width="24" height="24" rx="12" fill="white" fill-opacity="0.3"/>
                    <rect x="6.33295" y="18.4546" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-45 6.33295 18.4546)" fill="#1C1C1C"/>
                    <rect x="18.4548" y="19.667" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-135 18.4548 19.667)" fill="#1C1C1C"/>
                </svg>`;
                
                // 克隆元素以避免修改原始DOM
                const firstDialogClone = membershipCouponDialogFirst.cloneNode(true);
                firstDialogClone.style.display = 'block';
                
                Swal.fire({
                    showCloseButton: true,
                    showCancelButton: true,
                    showConfirmButton: true,
                    html: firstDialogClone,
                    closeButtonHtml: closeBtnHtml,
                    confirmButtonText: "Redeem",
                    cancelButtonText: "Cancel",
                    customClass: {
                        container: "membership-coupon-popup-container",
                        popup: "membership-coupon-popup",
                    },
                
                }).then((result) => {
                    if(result.isConfirmed){
                        const modal_html = `<div class=" is-loading"></div>`;
                        Swal.fire({
                            html: modal_html,
                            showCloseButton: false,
                            showCancelButton: false,
                            showConfirmButton: false,
                            customClass: {
                                container: "membership-coupon-popup-container",
                                popup: "membership-coupon-popup",
                            },
                        });
                        this.exchangeGiftCardCoupon(couponInfo.giftCardTemplateId).then(resp => {
                            if(resp.code === "000000"){
                                this.confirmGiftCardCoupon(membershipCouponDialogSuccess.cloneNode(true), couponInfo, closeBtnHtml,giftCardCouponContainer);
                            }else{
                                this.deleteRecordIdData();
                                Swal.fire(
                                    {
                                        toast: true,
                                        position: 'center',
                                        title: resp.msg,
                                        customClass: {
                                        popup: 'custom-error-toast',
                                        container: 'custom-error-toast-container',
                                        },
                                        iconHtml:this.toastErrorIcon,
                                        showConfirmButton: false,
                                        timer: 6000,
                                    }
                                )
                            }
                        }).catch(err=>{
                            this.deleteRecordIdData();
                            if(err.message.includes('accessToken')){
                                const loginHref = sessionStorage.getItem("loginHref")
                                window.location.href = loginHref;
                            }else{
                                Swal.close();
                            }
                        })
                    }else{
                        this.deleteRecordIdData();
                    }
                });
            }
        }
        async redeemProductCardCoupon(couponId,productCardCouponContainer){
            
            const couponInfo = this.productCardCouponData.contentList.find(item => item.couponTemplateId == couponId);
            
             const couponLimitInfo = {
                email:this.customerEmail,
                type:'product_coupon',
                limitCount:Number(window.customerSetting.product_coupon.limitCount),
                limitDay:Number(window.customerSetting.product_coupon.limitDay)
            }
            await this.checkCouponLimit(couponLimitInfo);
            if(!this.isRedeem){ 
                this.renderToast(this.toastTipsIcon,window.customerSetting.product_coupon.not_enough_times_text);
                return ;
            }
            if(couponInfo.stock > 0 && this.isRedeem){
                const membershipCouponDialogFirst = productCardCouponContainer.querySelector(".membership-coupon-dialog-content-first");
                const membershipCouponDialogSuccess = productCardCouponContainer.querySelector(".membership-coupon-dialog-content-success");
                const rays_numer = membershipCouponDialogFirst.querySelector('.rays-number');
                rays_numer.innerHTML = couponInfo.redeemBonusPoint;
                let closeBtnHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                    <rect x="1" y="1" width="24" height="24" rx="12" fill="white" fill-opacity="0.3"/>
                    <rect x="6.33295" y="18.4546" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-45 6.33295 18.4546)" fill="#1C1C1C"/>
                    <rect x="18.4548" y="19.667" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-135 18.4548 19.667)" fill="#1C1C1C"/>
                </svg>`;
                
                // 克隆元素以避免修改原始DOM
                const firstDialogClone = membershipCouponDialogFirst.cloneNode(true);
                firstDialogClone.style.display = 'block';
                
                Swal.fire({
                    showCloseButton: true,
                    showCancelButton: true,
                    showConfirmButton: true,
                    html: firstDialogClone,
                    closeButtonHtml: closeBtnHtml,
                    confirmButtonText: "Redeem",
                    cancelButtonText: "Cancel",
                    customClass: {
                        container: "membership-coupon-popup-container",
                        popup: "membership-coupon-popup",
                    },
                
                }).then((result) => {
                    if(result.isConfirmed){
                        const modal_html = `<div class=" is-loading"></div>`;
                        Swal.fire({
                            html: modal_html,
                            showCloseButton: false,
                            showCancelButton: false,
                            showConfirmButton: false,
                            customClass: {
                                container: "membership-coupon-popup-container",
                                popup: "membership-coupon-popup",
                            },
                        });
                        this.exchangeCoupon(couponInfo.couponTemplateId).then(resp => {
                            if(resp.code === "000000"){
                                couponInfo.couponCode = resp.data.couponCode;
                                this.confirmProductCardCoupon(membershipCouponDialogSuccess.cloneNode(true), couponInfo, closeBtnHtml,productCardCouponContainer);
                            }else{
                                this.deleteRecordIdData();
                                Swal.fire(
                                    {
                                        toast: true,
                                        position: 'center',
                                        title: resp.msg,
                                        customClass: {
                                        popup: 'custom-error-toast',
                                        container: 'custom-error-toast-container',
                                        },
                                        iconHtml:this.toastErrorIcon,
                                        showConfirmButton: false,
                                        timer: 6000,
                                    }
                                )
                            }
                        }).catch(err=>{
                            this.deleteRecordIdData();
                            if(err.message.includes('accessToken')){
                                const loginHref = sessionStorage.getItem("loginHref")
                                window.location.href = loginHref;
                            }else{
                                Swal.close();
                            }
                        })
                    }else{
                        this.deleteRecordIdData();
                    }
                });
            }
        }
        confirmRedeemCoupon(membershipCouponDialogSuccess, couponInfo, closeBtnHtml,memberCouponContainer){
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency = formatter.formatToParts(0).find(p => p.type === 'currency').value;
            const permanent_valid_text = memberCouponContainer.getAttribute('permanent_valid_text');
            
            // 克隆元素以避免修改原始DOM
            const successDialogClone = membershipCouponDialogSuccess.cloneNode(true);
            successDialogClone.querySelector('.membership-coupon-item').innerHTML = `
                <div class="membership-coupon-top">
                    <div class="coupon-l">
                        <div class="coupon-name">
                            ${couponInfo.couponTypeName === 'per_total_discount' ? `<span class="copun-currency">${currency}</span>`:'' }
                            <span x-text="coupon.couponAmount">${couponInfo.couponAmount.toFixed(0)}</span>
                            ${couponInfo.couponTypeName === 'percentage_discount' ? `<span class="copun-currency">%</span>`:'' }
                        </div>
                        <div class="account-coupon-info">
                                ${this.messages.couponInfo.coupon_text}
                                <span x-text="coupon.minPurchase">${currency}${couponInfo.minPurchase}</span>
                        </div>
                    </div>
                </div>
                <div class="membership-coupon-b">
                    <div class="membership-coupon-b-top">
                        <div class="membership-coupon-b-top-content">
                            <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.coupon}</div>
                            <div class="membership-coupon-b-top-content-des">
                                ${couponInfo.couponCode}
                            </div>
                        </div>
                        <div class="membership-coupon-b-top-button membership-coupon-b-top-button-copy" data-coupon-id="${couponInfo.couponTemplateId}" >
                            ${this.messages.couponInfo.redeem_copy}
                        </div>
                        
                    </div>
                    <div class="membership-coupon-b-line"></div>
                    <div class="membership-coupon-b-bottom">
                        <div class="membership-coupon-b-bottom-time">
                            ${couponInfo.cutoffType == 2 ? `${permanent_valid_text}` : `` }
                            ${couponInfo.cutoffType == 0 ? `${this.messages.couponInfo.valid_until} ${couponInfo.couponExpires.split(' ')[0]}` : `` }
                            ${couponInfo.cutoffType == 1 ? `${this.messages.couponInfo.valid_until} ${this.couponExpiresHandler(couponInfo)}` : `` }
                        </div>
                    </div>
                    
                </div>
            `
            let membershipCouponRuleHtml = ``;
            if(couponInfo.couponRuleList.length > 0) {
                couponInfo.couponRuleList.forEach(rule => {
                    membershipCouponRuleHtml += `
                        <div class="membership-coupon-b-bottom-rule">${rule}</div>
                    `;
                });
            }
            
            successDialogClone.querySelector('.membership-coupon-b-bottom-rules-box').innerHTML = membershipCouponRuleHtml;
        
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: successDialogClone,
                closeButtonHtml: closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
            }).then(() => {
                // 弹窗关闭后清理操作
            });

            const copyButton = successDialogClone.querySelector('.membership-coupon-b-top-button-copy');
            if (copyButton) {
                copyButton.addEventListener('click', () => {
                    // 防止重复点击
                    if (copyButton.classList.contains('copied')) return;
                    
                    navigator.clipboard.writeText(couponInfo.couponCode).then(() => {
                        // 显示打勾SVG图标
                        const originalText = copyButton.textContent;
                        copyButton.innerHTML = `${originalText}
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.3332 4L5.99984 11.3333L2.6665 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        `;
                        copyButton.classList.add('copied');
                        
                        // 3秒后恢复原始状态
                        setTimeout(() => {
                            copyButton.innerHTML = originalText;
                            copyButton.classList.remove('copied');
                        }, 3000);
                    }).catch(err => {
                        console.error('Failed to copy coupon code: ', err);
                    });
                });
            }
        }

        confirmGiftCardCoupon(membershipCouponDialogSuccess, couponInfo, closeBtnHtml,memberCouponContainer){
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency = formatter.formatToParts(0).find(p => p.type === 'currency').value;
            const permanent_valid_text = memberCouponContainer.getAttribute('permanent_valid_text');
            
            // 克隆元素以避免修改原始DOM
            const successDialogClone = membershipCouponDialogSuccess.cloneNode(true);
            successDialogClone.querySelector('.membership-coupon-item').innerHTML = `
                <div class="membership-coupon-top">
                    <div class="coupon-l">
                        <div class="coupon-name">
                            <span class="copun-currency">${currency}</span>
                            <span x-text="coupon.couponAmount">${couponInfo.giftCardAmount.toFixed(0)}</span>
                        </div>
                        <div class="account-coupon-info">
                                ${this.messages.couponInfo.coupon_text}
                            <span x-text="coupon.minPurchase">${currency}${couponInfo.redeemBonusPoint}</span>
                        </div>
                    </div>
                </div>
                <div class="membership-coupon-b">
                    <div class="membership-coupon-b-top">
                        <div class="membership-coupon-b-top-content">
                            <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.gift_card_code}</div>
                            <div class="membership-coupon-b-top-content-des">
                                ${this.messages.couponInfo.check_email}
                            </div>
                        </div>
                    </div>
                    <div class="membership-coupon-b-line"></div>
                    <div class="membership-coupon-b-bottom">
                        <div class="membership-coupon-b-bottom-time">
                            ${couponInfo.cutoffType == 2 ? `${permanent_valid_text}` : `` }
                            ${couponInfo.cutoffType == 0 ? `${this.messages.couponInfo.valid_until} ${couponInfo.giftCardExpires.split(' ')[0]}` : `` }
                            ${couponInfo.cutoffType == 1 ? `${this.messages.couponInfo.valid_until} ${this.couponExpiresHandler(couponInfo)}` : `` }
                        </div>
                    </div>
                </div>
            `
            let membershipCouponRuleHtml = ``;
            if(couponInfo.giftCardRuleList.length > 0) {
                couponInfo.giftCardRuleList.forEach(rule => {
                    membershipCouponRuleHtml += `
                        <div class="membership-coupon-b-bottom-rule">${rule}</div>
                    `;
                });
            }
            
            successDialogClone.querySelector('.membership-coupon-b-bottom-rules-box').innerHTML = membershipCouponRuleHtml;
        
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: successDialogClone,
                closeButtonHtml: closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
            }).then(() => {
                // 弹窗关闭后清理操作
            });
        }
        confirmProductCardCoupon(membershipCouponDialogSuccess, couponInfo, closeBtnHtml,productCardCouponContainer){
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency = formatter.formatToParts(0).find(p => p.type === 'currency').value;
            const permanent_valid_text = productCardCouponContainer.getAttribute('permanent_valid_text');
            
            // 克隆元素以避免修改原始DOM
            const successDialogClone = membershipCouponDialogSuccess.cloneNode(true);
            successDialogClone.querySelector('.membership-coupon-item').innerHTML = `
                <div class="membership-coupon-top membership-coupon-product-card">
                    
                    ${couponInfo.couponTemplateProductDetailContentList[0].productImageUrl ? 
                    `<div class="product-card-img" >
                        <img width="100%" src="${couponInfo.couponTemplateProductDetailContentList[0].productImageUrl}" />
                    </div>`:
                    `<div class="product-card-img" style="background:#F2FCFF;"></div>`}
                    <div class="product-card-content">
                        <div class="product-card-content-title">${couponInfo.couponTemplateProductDetailContentList[0].productName}</div>
                        <div class="product-card-content-sku">${couponInfo.couponTemplateProductDetailContentList[0].sku}</div>
                        <div class="product-card-content-price">
                            <span class="free">${this.messages.couponInfo.free}</span>
                            <span class="underline-price">${currency}${couponInfo.couponTemplateProductDetailContentList[0].price}</span>
                        </div>
                    </div>
                </div>
                <div class="membership-coupon-item-line-box">
                    <div class="membership-coupon-item-line"></div>
                </div>
                <div class="membership-coupon-b">
                    <div class="membership-coupon-b-top">
                        <div class="membership-coupon-b-top-content">
                            <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.code}:
                                <span class="membership-coupon-b-top-content-des">
                                    ${couponInfo.couponCode}
                                </span>
                            </div>
                        </div>
                        <product-form>
                            <form class="js-product-form" id="form-id-${couponInfo.couponTemplateProductDetailContentList[0].productId}"  method="post" action="/cart/add" enctype="multipart/form-data" novalidate="novalidate" accept-charset="UTF-8">
                                <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
                                <input type="hidden" name="id" value="${couponInfo.couponTemplateProductDetailContentList[0].productId}" disabled>
                                <button name="add" class="membership-coupon-b-top-button membership-coupon-b-top-button-copy btn btn--secondary quick-add-view-btn" data-coupon-id="${couponInfo.couponTemplateId}" >
                                    ${this.messages.couponInfo.redeem_copy}
                                </button>
                            </form>
                        </product-form>
                    </div>
                </div>
            `
            let membershipCouponRuleHtml = ``;
            if(couponInfo.couponRuleList.length > 0) {
                couponInfo.couponRuleList.forEach(rule => {
                    membershipCouponRuleHtml += `
                        <div class="membership-coupon-b-bottom-rule">${rule}</div>
                    `;
                });
            }
            
            successDialogClone.querySelector('.membership-coupon-b-bottom-rules-box').innerHTML = membershipCouponRuleHtml;
        
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: successDialogClone,
                closeButtonHtml: closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
            }).then(() => {
                // 弹窗关闭后清理操作
            });
            const copyButton = successDialogClone.querySelector('.membership-coupon-b-top-button-copy');
            if (copyButton) {
                copyButton.addEventListener('click', () => {
                    let maxTime= 0
                    let copyButtonTimer = setInterval(() => {
                        if(copyButton.classList.contains('is-success')){
                            Swal.close();
                            clearInterval(copyButtonTimer);
                        }
                        maxTime += 50;
                    }, 10);
                    if(maxTime >= 3000){
                        Swal.close();
                        clearInterval(copyButtonTimer);
                    }
                    // 防止重复点击
                    if (copyButton.classList.contains('copied')) return;
                    
                    navigator.clipboard.writeText(couponInfo.couponCode).then(() => {
                        // 显示打勾SVG图标
                        const originalText = copyButton.textContent;
                        // copyButton.innerHTML = `${originalText}
                        //     <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        //         <path d="M13.3332 4L5.99984 11.3333L2.6665 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        //     </svg>
                        // `;
                        copyButton.classList.add('copied');
                        
                        // 3秒后恢复原始状态
                        setTimeout(() => {
                            copyButton.innerHTML = originalText;
                            copyButton.classList.remove('copied');
                        }, 3000);
                    }).catch(err => {
                        console.error('Failed to copy coupon code: ', err);
                    });
                });
            }
        }
        renderMemberCoupon() {
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency = formatter.formatToParts(0).find(p => p.type === 'currency').value;
            this.memberCouponContainers.forEach(memberCouponContainer =>{
                const permanent_valid_text = memberCouponContainer.getAttribute('permanent_valid_text');
                const pageCouponTemplateData = this.pageCouponTemplateData.contentList;
                const loginHref_ = memberCouponContainer.querySelector('.coupon-login-url').getAttribute('rg-login-href');
                sessionStorage.setItem('loginHref',loginHref_)
                this.customerEmail = memberCouponContainer.getAttribute('customer-email') || '';
                if(pageCouponTemplateData?.length > 0){
                    let couponHtml = '';
                    pageCouponTemplateData.forEach(item => {
                        let rulesHtml = ''
                        if(item.couponRuleList.length > 0) {
                            item.couponRuleList.forEach(rule => {
                                rulesHtml += `
                                    <div class="membership-coupon-b-bottom-rule">${rule}</div>
                                `;
                            });
                        }
                        couponHtml += `
                            <div class="membership-coupon-item ${item.stock <= 0 ? 'out-of-stock' : '' }">
                                <div class="membership-coupon-top">
                                    <div class="coupon-l">
                                    <div class="coupon-name">
                                    ${item.couponTypeName === 'per_total_discount' ? `<span class="copun-currency">${currency}</span>`:'' }
                                        <span x-text="coupon.couponAmount">${item.couponAmount.toFixed(0)}</span>
                                    ${item.couponTypeName === 'percentage_discount' ? `<span class="copun-currency">%</span>`:'' }
                                    </div>
                                    <div class="account-coupon-info">
                                        ${this.messages.couponInfo.coupon_text}
                                        <span x-text="coupon.minPurchase">${currency}${item.minPurchase}</span>
                                    </div>
                                    </div>
                                </div>
                                <div class="membership-coupon-b">
                                    <div class="membership-coupon-b-top">
                                        <div class="membership-coupon-b-top-content">
                                            <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.coupon}</div>
                                            <div class="membership-coupon-b-top-content-des">
                                                ${this.messages.couponInfo.redeem_text}
                                                <span class="rays-number">${item.redeemBonusPoint}</span>
                                                ${this.messages.couponInfo.rays}
                        
                                            </div>
                                        </div>
                                            <div class="membership-coupon-b-top-button ${item.stock > 0 ? '' :'membership-coupon-b-top-button-disabled'}" data-coupon-id="${item.couponTemplateId}" >
                                                ${this.messages.couponInfo.redeem}
                                            </div>
                                        
                                    </div>
                                    <div class="membership-coupon-b-line"></div>
                                    <div class="membership-coupon-b-bottom">
                                        <div class="membership-coupon-b-bottom-time">
                                            ${item.cutoffType == 2 ? `${permanent_valid_text}` : `` }
                                            ${item.cutoffType == 0 ? `${this.messages.couponInfo.valid_until} ${item.couponExpires.split(' ')[0]}` : `` }
                                            ${item.cutoffType == 1 ? `${this.messages.couponInfo.valid_until} ${this.couponExpiresHandler(item)}` : `` }
                                        </div>
                                        <div class="membership-coupon-b-bottom-rules-text">
                                            ${this.messages.couponInfo.usage_rules}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                <path d="M9.85718 4.07132L6.12125 7.80725C6.05431 7.8742 5.94576 7.8742 5.87882 7.80725L2.14289 4.07132" stroke="#777777" stroke-width="0.857143" stroke-linecap="round"/>
                                            </svg>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div class="membership-coupon-b-bottom-rules">
                                    <div class="membership-coupon-b-bottom-rules-box">
                                        ${rulesHtml}
                                    </div> 
                                </div>
                                
                                <div class="membership-coupon-b-position">
                                    ${item.stock > 0 ? `${item.stock} ${this.messages.couponInfo.available}` : `${this.messages.couponInfo.out_of_stock}`} 
                                </div>
                            </div>
                        `;
                }) 
                memberCouponContainer.querySelector('.membership-coupon-container').innerHTML = couponHtml;
                
                // 添加鼠标事件监听器
                const couponItems = memberCouponContainer.querySelectorAll('.membership-coupon-item');
                couponItems.forEach(item => {
                    const rulesElement = item.querySelector('.membership-coupon-b-bottom-rules-text');
                    const rules = item.querySelector('.membership-coupon-b-bottom-rules');
                    const rulesBox = item.querySelector('.membership-coupon-b-bottom-rules-box');
                    const redeemBtn = item.querySelector('.membership-coupon-b-top-button')
                    
                    if (rulesElement && rules) {
                        rulesElement.addEventListener('mouseenter', () => {
                            rules.classList.add('is-open');
                            rulesElement.classList.add('is-open');
                            rules.style.bottom = ` -${rulesBox.offsetHeight}px`
                        });
                        
                        rulesElement.addEventListener('mouseleave', () => {
                            rules.classList.remove('is-open');
                            rulesElement.classList.remove('is-open');
                        });
                        
                        rulesElement.addEventListener('click', (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            if (rules.classList.contains('is-open')) {
                                rules.classList.remove('is-open');
                                rulesElement.classList.remove('is-open');
                            } else {
                                rules.classList.add('is-open');
                                rulesElement.classList.add('is-open');
                                rules.style.bottom = ` -${rulesBox.offsetHeight}px`;
                            }
                        });
                    }
                    if(redeemBtn){
                        redeemBtn.addEventListener('click', (event) => {
                            const couponId = event.target.getAttribute('data-coupon-id');
                            const loginHref = memberCouponContainer.getAttribute('rg-login-href');
                            
                            if(!this.isLoggedIn) {
                                window.location.href = loginHref;
                            } else{
                                if(redeemBtn.classList.contains('membership-coupon-b-top-button-disabled')) return;
                                this.redeemCoupon(couponId,memberCouponContainer);
                            }
                        });
                    }
                });
                }
            })
            
        }
        renderGiftCardCoupon(){
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency = formatter.formatToParts(0).find(p => p.type === 'currency').value;
            this.giftCardCouponContainers.forEach(giftCardCouponContainer =>{
                const permanent_valid_text = giftCardCouponContainer.getAttribute('permanent_valid_text');
                const giftCard_img = giftCardCouponContainer.getAttribute('gift-card-bg-img');
                const loginHref_ = giftCardCouponContainer.querySelector('.coupon-login-url').getAttribute('rg-login-href');
                sessionStorage.setItem('loginHref',loginHref_)
                const giftCardCouponData = this.giftCardCouponData.giftCardTemplateContents;
                this.customerEmail = giftCardCouponContainer.getAttribute('customer-email') || '';
                if(giftCardCouponData?.length > 0){
                    let couponHtml = '';
                    giftCardCouponData.forEach(item => {
                        let rulesHtml = ''
                        if(item.giftCardRuleList.length > 0) {
                            item.giftCardRuleList.forEach(rule => {
                                rulesHtml += `
                                    <div class="membership-coupon-b-bottom-rule">${rule}</div>
                                `;
                            });
                        }
                        couponHtml += `
                            <div class="membership-coupon-item ${item.stock <= 0 ? 'out-of-stock' : '' }">
                                <div class="membership-coupon-top-box">
                                    <div class="membership-coupon-top" style="background: url('${giftCard_img}') center center no-repeat;background-size:cover;">
                                        <div class="coupon-l">
                                            <div class="coupon-name">
                                                <span class="copun-currency">${currency}</span>
                                                <span x-text="coupon.couponAmount">${item.giftCardAmount.toFixed(0)}</span>
                                            </div>
                                        </div>
                                        <div class="membership-coupon-b-position">
                                            ${item.stock > 0 ? `${item.stock} ${this.messages.couponInfo.available}` : `${this.messages.couponInfo.out_of_stock}`} 
                                        </div>
                                    </div>
                                </div>
                                <div class="membership-coupon-item-line-box">
                                    <div class="membership-coupon-item-line"></div>
                                </div>
                                <div class="membership-coupon-b-box">
                                    <div class="membership-coupon-b">
                                        <div class="membership-coupon-b-top">
                                            <div class="membership-coupon-b-top-content">
                                                <div class="membership-coupon-b-top-content-title">${item.giftCardName}</div>
                                                <div class="membership-coupon-b-top-content-des">
                                                    ${this.messages.couponInfo.redeem_text}
                                                    <span class="rays-number">${item.redeemBonusPoint}</span>
                                                    ${this.messages.couponInfo.rays}
                                                </div>
                                            </div>
                                                <div class="membership-coupon-b-top-button ${item.stock > 0 ? '' :'membership-coupon-b-top-button-disabled'}" data-coupon-id="${item.giftCardTemplateId}" >
                                                    ${this.messages.couponInfo.redeem}
                                                </div>
                                            
                                        </div>
                                        <div class="membership-coupon-b-bottom">
                                            <div class="membership-coupon-b-bottom-time">
                                                ${item.cutoffType == 2 ? `${permanent_valid_text}` : `` }
                                                ${item.cutoffType == 0 ? `${this.messages.couponInfo.valid_until} ${item.giftCardExpires.split(' ')[0]}` : `` }
                                                ${item.cutoffType == 1 ? `${this.messages.couponInfo.valid_until} ${this.couponExpiresHandler(item)}` : `` }
                                            </div>
                                            <div class="membership-coupon-b-bottom-rules-text">
                                                ${this.messages.couponInfo.usage_rules}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                    <path d="M9.85718 4.07132L6.12125 7.80725C6.05431 7.8742 5.94576 7.8742 5.87882 7.80725L2.14289 4.07132" stroke="#777777" stroke-width="0.857143" stroke-linecap="round"/>
                                                </svg>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="membership-coupon-b-bottom-rules">
                                        <div class="membership-coupon-b-bottom-rules-box">
                                            ${rulesHtml}
                                        </div> 
                                    </div>
                                </div>
                                
                                
                                
                            </div>
                        `;
                }) 
                giftCardCouponContainer.querySelector('.membership-coupon-container').innerHTML = couponHtml;
                
                // 添加鼠标事件监听器
                const couponItems = giftCardCouponContainer.querySelectorAll('.membership-coupon-item');
                couponItems.forEach(item => {
                    const rulesElement = item.querySelector('.membership-coupon-b-bottom-rules-text');
                    const rules = item.querySelector('.membership-coupon-b-bottom-rules');
                    const rulesBox = item.querySelector('.membership-coupon-b-bottom-rules-box');
                    const redeemBtn = item.querySelector('.membership-coupon-b-top-button')
                    
                    if (rulesElement && rules) {
                        rulesElement.addEventListener('mouseenter', () => {
                            rules.classList.add('is-open');
                            rulesElement.classList.add('is-open');
                            rules.style.bottom = ` -${rulesBox.offsetHeight}px`
                        });
                        
                        rulesElement.addEventListener('mouseleave', () => {
                            rules.classList.remove('is-open');
                            rulesElement.classList.remove('is-open');
                        });
                        
                        rulesElement.addEventListener('click', (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            if (rules.classList.contains('is-open')) {
                                rules.classList.remove('is-open');
                                rulesElement.classList.remove('is-open');
                            } else {
                                rules.classList.add('is-open');
                                rulesElement.classList.add('is-open');
                                rules.style.bottom = ` -${rulesBox.offsetHeight}px`;
                            }
                        });
                    }
                    if(redeemBtn){
                        redeemBtn.addEventListener('click', (event) => {
                            const couponId = event.target.getAttribute('data-coupon-id');
                            const loginHref = giftCardCouponContainer.getAttribute('rg-login-href');
                            
                            if(!this.isLoggedIn) {
                                window.location.href = loginHref;
                            } else{
                                if(redeemBtn.classList.contains('membership-coupon-b-top-button-disabled')) return;
                                this.redeemGiftCardCoupon(couponId,giftCardCouponContainer);
                            }
                        });
                    }
                });
                }
            })
            
        }
        renderProductCardCoupon(){
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency = formatter.formatToParts(0).find(p => p.type === 'currency').value;
            this.productCardCouponContainers.forEach(productCardCouponContainer =>{
                const permanent_valid_text = productCardCouponContainer.getAttribute('permanent_valid_text');
                const loginHref_ = productCardCouponContainer.querySelector('.coupon-login-url').getAttribute('rg-login-href');
                sessionStorage.setItem('loginHref',loginHref_)
                this.customerEmail = productCardCouponContainer.getAttribute('customer-email') || '';
                const productCardCouponData = this.productCardCouponData.contentList;
                if(productCardCouponData?.length > 0){
                    let couponHtml = '';
                    productCardCouponData.forEach(item => {
                        if(item.couponTemplateProductDetailContentList.length > 0){
                            let rulesHtml = ''
                            if(item.couponRuleList.length > 0) {
                                item.couponRuleList.forEach(rule => {
                                    rulesHtml += `
                                        <div class="membership-coupon-b-bottom-rule">${rule}</div>
                                    `;
                                });
                            }
                            couponHtml += `
                                <div class="membership-coupon-item ${item.stock <= 0 ? 'out-of-stock' : '' }">
                                    <div class="membership-coupon-top-box">
                                        <div class="membership-coupon-top" style="background:#F2FCFF;">
                                            ${item.couponTemplateProductDetailContentList[0].productImageUrl? `<img width="100%" height="100%" src="${item.couponTemplateProductDetailContentList[0].productImageUrl}" alt="" class="membership-coupon-item-img">` :``}
                                            <div class="membership-coupon-b-position">
                                                ${item.stock > 0 ? `${item.stock} ${this.messages.couponInfo.available}` : `${this.messages.couponInfo.out_of_stock}`} 
                                            </div>
                                        </div>
                                    </div>
                                    <div class="product-card-coupon-content">
                                        <a class="product-title" target="_blank" href="${item.couponTemplateProductDetailContentList[0].productUrl}">${item.couponTemplateProductDetailContentList[0].productName}</a>
                                        <div class="product-sku-name">${item.couponTemplateProductDetailContentList[0].sku}</div>
                                        <div class="product-price">${currency}${item.couponTemplateProductDetailContentList[0].price}</div>
                                    </div>
                                    <div class="membership-coupon-item-line-box">
                                        <div class="membership-coupon-item-line"></div>
                                    </div>
                                    <div class="membership-coupon-b-box">
                                        <div class="membership-coupon-b">
                                            <div class="membership-coupon-b-top">
                                                <div class="membership-coupon-b-top-content">
                                                    <div class="membership-coupon-b-top-content-des">
                                                        ${this.messages.couponInfo.redeem_text}
                                                        <span class="rays-number">${item.redeemBonusPoint}</span>
                                                        ${this.messages.couponInfo.rays}
                                                    </div>
                                                </div>
                                                <div class="membership-coupon-b-top-button ${item.stock > 0 ? '' :'membership-coupon-b-top-button-disabled'}" data-coupon-id="${item.couponTemplateId}" >
                                                    ${this.messages.couponInfo.redeem}
                                                </div>
                                                
                                            </div>
                                            <div class="membership-coupon-b-bottom">
                                                <div class="membership-coupon-b-bottom-time">
                                                    ${item.cutoffType == 2 ? `${permanent_valid_text}` : `` }
                                                    ${item.cutoffType == 0 ? `${this.messages.couponInfo.valid_until} ${item.couponExpires.split(' ')[0]}` : `` }
                                                    ${item.cutoffType == 1 ? `${this.messages.couponInfo.valid_until} ${this.couponExpiresHandler(item)}` : `` }
                                                </div>
                                                <div class="membership-coupon-b-bottom-rules-text">
                                                    ${this.messages.couponInfo.usage_rules}
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                        <path d="M9.85718 4.07132L6.12125 7.80725C6.05431 7.8742 5.94576 7.8742 5.87882 7.80725L2.14289 4.07132" stroke="#777777" stroke-width="0.857143" stroke-linecap="round"></path>
                                                    </svg>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div class="membership-coupon-b-bottom-rules">
                                            <div class="membership-coupon-b-bottom-rules-box">
                                                ${rulesHtml}
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                            `;

                        }

                     }) 
                    productCardCouponContainer.querySelector('.membership-coupon-container').innerHTML = couponHtml;
                    // 添加鼠标事件监听器
                    const couponItems = productCardCouponContainer.querySelectorAll('.membership-coupon-item');
                    couponItems.forEach(item => {
                        const rulesElement = item.querySelector('.membership-coupon-b-bottom-rules-text');
                        const rules = item.querySelector('.membership-coupon-b-bottom-rules');
                        const rulesBox = item.querySelector('.membership-coupon-b-bottom-rules-box');
                        const redeemBtn = item.querySelector('[data-coupon-id]')
                        
                        if (rulesElement && rules) {
                            rulesElement.addEventListener('mouseenter', () => {
                                rules.classList.add('is-open');
                                rulesElement.classList.add('is-open');
                                rules.style.bottom = ` -${rulesBox.offsetHeight}px`
                            });
                            
                            rulesElement.addEventListener('mouseleave', () => {
                                rules.classList.remove('is-open');
                                rulesElement.classList.remove('is-open');
                            });
                            
                            rulesElement.addEventListener('click', (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                
                                if (rules.classList.contains('is-open')) {
                                    rules.classList.remove('is-open');
                                    rulesElement.classList.remove('is-open');
                                } else {
                                    rules.classList.add('is-open');
                                    rulesElement.classList.add('is-open');
                                    rules.style.bottom = ` -${rulesBox.offsetHeight}px`;
                                }
                            });
                        }
                        if(redeemBtn){
                            redeemBtn.addEventListener('click', (event) => {
                                const couponId = event.target.getAttribute('data-coupon-id');
                                const loginHref = productCardCouponContainer.getAttribute('rg-login-href');
                                
                                if(!this.isLoggedIn) {
                                    window.location.href = loginHref;
                                } else{
                                    if(redeemBtn.classList.contains('membership-coupon-b-top-button-disabled')) return;
                                    this.redeemProductCardCoupon(couponId,productCardCouponContainer);
                                }
                            });
                        }
                    });
                }
            })
            
        }
        exchangeCoupon(couponTemplateId) {
            // 兑换优惠券
            const options = {
                method: "POST",
                body: JSON.stringify({
                    couponTemplateId: couponTemplateId,
                }),
            };
            
            return this._request('/exchange_coupon', options)
                .then(resp => {
                    if (resp.code === "000000") {
                        this.exchangeResult = resp.data;
                    }
                    return resp;
                })
                .catch(error => {
                    throw error;
                });
        }

        exchangeGiftCardCoupon(giftCardTemplateId) {
            // 兑换
            const options = {
                method: "POST",
                body: JSON.stringify({
                    giftCardTemplateId: giftCardTemplateId,
                }),
            };
            
            return this._request('/exchange_gift_card', options)
                .then(resp => {
                    if (resp.code === "000000") {
                        this.exchangeGiftCardResult = resp.data;
                    }
                    return resp;
                })
                .catch(error => {
                    throw error;
                });
        }
        renderAccountCard() {
            const _data = this.merberData;
            if (!_data) {
                return;
            }

            // 等级映射
            const levelMap = {
                'EG1': 'L1',
                'EG2': 'L2', 
                'EG3': 'L3',
                'EG4': 'L4'
            };

            const currentLevel = levelMap[_data.userLevelInfo] || 'L1';
            const currentPoints = _data.userBonusPoints || 0;
            const expiringPoints = _data.userExpiringSoonBonusPoints || 0;
            const nextLevelPoints = _data.userNextBonusPoints || 0;
            const progressProportion = parseFloat(_data.userNextBonusPointsProportion || 0);
            const pendingRays = _data.userFrozenBonusPoints || 0;


            // 计算还需多少积分升级
            const pointsNeeded = Math.max(0, nextLevelPoints - currentPoints);

            // 更新当前等级
            const currentLevelElements = document.querySelectorAll('.rg-info-value');
            if (currentLevelElements[0]) {
                currentLevelElements[0].textContent = currentLevel;
            }

            // 更新积分余额
            if (currentLevelElements[1]) {
                currentLevelElements[1].textContent = `${currentPoints} Rays`;
            }

            // 更新pending积分
            if (currentLevelElements[2]) {
                currentLevelElements[2].textContent = `${pendingRays} Rays`;
            }

            // 更新即将过期的积分
            if (currentLevelElements[3]) {
                currentLevelElements[3].textContent = `${expiringPoints} Rays`;
            }

            // 更新进度条
            const progressBar = document.querySelector('.rg-level-progress-bar');
            if (progressBar) {
                // 获取当前等级数字 (L1=1, L2=2, L3=3, L4=4)
                const currentLevelNum = parseInt(currentLevel.replace('L', ''));
                
                // 基础进度：前面已完成等级的进度 (每个等级占33.3%)
                const baseProgress = (currentLevelNum - 1) * 33.3;
                
                // 当前等级内的进度：33.3% * 当前等级进度比例
                const currentLevelProgress = 33.3 * progressProportion;
                
                // 总进度 = 基础进度 + 当前等级内进度
                const totalProgress = Math.min(100, baseProgress + currentLevelProgress);
                
                progressBar.style.width = `${totalProgress}%`;
            }

            // 更新等级徽章
            const levelBadges = document.querySelectorAll('.rg-level-badge');
            levelBadges.forEach((badge, index) => {
                badge.classList.remove('rg-level-current', 'rg-level-completed');
                const badgeLevel = index + 1;
                const currentLevelNum = parseInt(currentLevel.replace('L', ''));
                
                if (badgeLevel === currentLevelNum) {
                    badge.classList.add('rg-level-current');
                } else if (badgeLevel < currentLevelNum) {
                    // 当前等级之前的徽章标记为已完成
                    badge.classList.add('rg-level-completed');
                }
            });

            // 更新升级提示
            const levelTip = document.querySelector('.rg-level-tip');
            if (levelTip) {
                if (currentLevel === 'L4') {
                    levelTip.innerHTML = this.messages.congratulations;
                } else if (_data.isHighestLevel) {
                    levelTip.innerHTML = this.messages.highestLevel;
                } else {
                    const nextLevel = levelMap[_data.userNextLevelInfo] || 'L2';
                    levelTip.innerHTML = `<span style="font-weight: 600;">${nextLevelPoints} Rays</span> ${this.messages.raysNeeded} ${nextLevel}`;
                }
            }

            // 更新标题中的等级徽章
            const titleLevelText = document.querySelector('.membership-title .level-text');
            if (titleLevelText) {
                titleLevelText.textContent = currentLevel;
            }


            // 更新membership-subtitle文案内容
            const membershipSubtitles = document.querySelectorAll('.has-login .membership-subtitle.rg-slide-p');
            membershipSubtitles.forEach(subtitle => {
                if (subtitle) {
                    subtitle.textContent = this.messages.levelMessages[currentLevel] || this.messages.levelMessages['L1'];
                }
            });
            
            

            // 更新权益描述内容
            this.updateBenefitsContent(_data.userLevelInfo);
        }

        // toast
        renderToast(toastIcon,msg,duration = 6000){
            Swal.fire(
                {
                    toast: true,
                    position: 'center',
                    title: msg,
                    customClass: {
                    popup: 'custom-error-toast',
                    container: 'custom-error-toast-container',
                    },
                    iconHtml:toastIcon,
                    showConfirmButton: false,
                    timer: duration,
                    didClose: () => {
                        this.playBtn.disabled = false;
                    }
                }
            )
        }
        initNoLoginContent() {
            const hasLoginContent = document.querySelector('.rg-user-login-wrap.rg-has-login');
            if (hasLoginContent) {
                hasLoginContent.style.display = 'none';
            }
            const noLoginContent = document.querySelector('.rg-user-login-wrap.no-login');
            if (noLoginContent) {
                const membershipBanner = noLoginContent.querySelector('.membership-banner')
                membershipBanner.style.bottom = '0';
                membershipBanner.style.top = '0';
                document.querySelector('.user-login-section-container').style.marginBottom = '0';
                noLoginContent.style.display = 'block';

            }
           
        }

        updateBenefitsContent(userLevelInfo) {
            const currentLevelData = this.EGMessageg[userLevelInfo] || this.EGMessageg['EG1'];
            
            // 获取权益容器
            const benefitsGrid = document.getElementById('rg-benefits-grid');
            if (!benefitsGrid) {
                return;
            }

            // 清空现有内容
            benefitsGrid.innerHTML = '';
            
            // 获取当前等级的权益列表
            const benefits = currentLevelData.benefits || [];
            
            // 动态生成权益项
            benefits.forEach((benefit, index) => {
                const benefitItem = document.createElement('div');
                benefitItem.className = 'rg-benefit-item';
                
                benefitItem.innerHTML = `
                    <div class="rg-benefit-icon">
                        ${benefit.icon || ''}
                    </div>
                    <div class="rg-benefit-content">
                        <div class="rg-benefit-title" title="${benefit.title}">${benefit.title}</div>
                        <div class="rg-benefit-desc" title="${benefit.description}">${benefit.description}</div>
                    </div>
                `;
                
                benefitsGrid.appendChild(benefitItem);
            });
            
            // 如果是移动端且权益超过1个，添加展开按钮
            if (benefits.length > 1) {
                const expandBtn = document.createElement('button');
                expandBtn.className = 'rg-benefits-expand-btn hide-pc';
                expandBtn.id = 'rg-benefits-expand-btn';
                expandBtn.innerHTML = `
                    <span class="rg-benefits-expand-text">${this.messages.expandButton.viewMore} ${benefits.length - 1} ${this.messages.expandButton.moreBenefits}</span>
                    <svg class="rg-benefits-expand-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.14 4.07L6 7.93L9.86 4.07" stroke="#777777" stroke-width="0.86" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                `;
                
                benefitsGrid.appendChild(expandBtn);
                
                // 延迟初始化展开功能，确保DOM元素完全创建
                setTimeout(() => {
                    this.initBenefitsExpand();
                }, 100);
            }
        }
        getUserDate() {
            // 使用封装的 _request 方法
            return this._request('/api/v1/account/security/get_security_info', {}, false, true)
                .then(resp => {
                    if (resp.code === "000000") {
                        this.userInfo = resp.data;
                    }
                    return resp;
                });
        }

        // 刷新 token：只刷新一次，并排队等待
        refreshAccessToken() {
            if (this.isRefreshing) {
                return this.refreshPromise;
            }

            // 如果 refreshToken 不存在，直接调用 handleLoginExpired 然后 reject
            if (!this.refreshToken) {
                this.handleLoginExpired();
                return Promise.reject(new Error("Refresh token not found"));
            }

            this.isRefreshing = true;

            this.refreshPromise = new Promise((resolve, reject) => {
                fetch(this.API_DOMAIN + "/api/v1/account/pc/do_refresh", {
                    method: "POST",
                    headers: {
                        "X-Token": this.accessToken,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        refreshToken: this.refreshToken,
                    }),
                })
                    .then(response => {
                        if (!response.ok) throw new Error("Refresh failed");
                        return response.json();
                    })
                    .then(resp => {
                        // 使用 js-cookie 设置 cookie（需要确保页面已加载 Cookies）
                        if (typeof Cookies !== 'undefined') {
                            Cookies.set(this.ACCESS_TOKEN_KEY, resp.data.accessToken, {
                                domain: ".renogy.com",
                                expires: 370,
                                sameSite: "strict",
                            });
                            Cookies.set(this.REFRESH_TOKEN_KEY, resp.data.refreshToken, {
                                domain: ".renogy.com",
                                expires: 370,
                                sameSite: "strict",
                            });
                        }

                        // 更新实例中的 token
                        this.accessToken = resp.data.accessToken;
                        this.refreshToken = resp.data.refreshToken;
                        
                        // 刷新成功，更新登录状态
                        this.isLoggedIn = true;

                        resolve(resp);

                        // 执行所有挂起请求
                        for (let i = 0; i < this.pendingRequests.length; i++) {
                            this.pendingRequests[i]();
                        }
                        this.pendingRequests = [];
                    })
                    .catch(err => {
                        // 清空挂起的请求队列，因为刷新失败了
                        this.pendingRequests = [];
                        this.handleLoginExpired();
                        reject(err);
                    })
                    .finally(() => {
                        this.isRefreshing = false;
                        this.refreshPromise = null;
                    });
            });

            return this.refreshPromise;
        }

        // 通用的 API 请求方法
        _request(apiPath, options = {}, isRetry = false, isFullUrl = false) {
            const requireAuth = options.requireAuth !== false;
            const acceptLanguage = options.acceptLanguage;
            const fetchOptions = { ...options };
            delete fetchOptions.requireAuth;
            delete fetchOptions.acceptLanguage;

            const apiUrl = isFullUrl ? apiPath : `/mem-service/api/v1/bigcommerce${apiPath}`;
            
            const includeToken = fetchOptions.includeToken !== false;
            delete fetchOptions.includeToken;

            fetchOptions.headers = fetchOptions.headers || {};
            fetchOptions.headers['Content-Type'] = 'application/json';
            if (acceptLanguage) {
                fetchOptions.headers['Accept-Language'] = acceptLanguage;
            }
            if (includeToken && this.accessToken) {
                fetchOptions.headers['X-Token'] = this.accessToken;
            }
            
            const url = isFullUrl ? apiUrl : `${this.API_DOMAIN}${apiUrl}`;
            
            return fetch(url, fetchOptions)
                .then(response => {
                    if (response.status === 401 && !isRetry && requireAuth) {
                        // Token 过期，排队等待刷新完成
                        return new Promise((resolve, reject) => {
                            this.pendingRequests.push(() => {
                                this._request(apiPath, options, true, isFullUrl).then(resolve).catch(reject);
                            });

                            // .catch(reject)
                            this.refreshAccessToken().catch(reject); // 刷新失败则中断所有请求
                        });
                    }

                    if (!response.ok) {
                        if (!requireAuth) {
                            return response.json().catch(() => null);
                        }
                        return response.text().then(text => {
                            // 清除 cookies
                            // this.handleLoginExpired();
                            // throw new Error(`HTTP Error ${response.status}: ${text}`);
                        });
                    }

                    return response.json();
                })
                .catch(error => {
                    // this.handleLoginExpired();
                    throw error;
                });
        }

        getMerberData() {
            // 获取用户权益信息 - 基于customer-account.js中的getInfo方法
            if (this.merberData) {
                return Promise.resolve(this.merberData);
            }

            if (this.memberDataPromise) {
                return this.memberDataPromise;
            }

            this.memberDataPromise = this._request('/get_user_information?storeId=' + this.storeId)
                .then(resp => {
                    if (resp && resp.code === "000000") {
                        this.merberData = resp.data;
                        this.isLoggedIn = true;
                    }
                    return resp;
                })
                .finally(() => {
                    this.memberDataPromise = null;
                });

            return this.memberDataPromise;
        }

        // member-center 新接口（/api/v1/dtc），独立于 getMerberData，供 user-login-cta 等组件使用
        _requestDtc(apiPath, options = {}, isRetry = false) {
            const requireAuth = options.requireAuth !== false;
            const acceptLanguage = options.acceptLanguage;
            const fetchOptions = { ...options };
            delete fetchOptions.requireAuth;
            delete fetchOptions.acceptLanguage;

            const apiUrl = `/api/v1/dtc${apiPath}`;

            fetchOptions.headers = fetchOptions.headers || {};
            fetchOptions.headers['Content-Type'] = 'application/json';
            if (acceptLanguage) {
                fetchOptions.headers['Accept-Language'] = acceptLanguage;
            }
            if (this.accessToken) {
                fetchOptions.headers['X-Token'] = this.accessToken;
            }

            const url = `${this.API_DOMAIN}${apiUrl}`;

            return fetch(url, fetchOptions)
                .then(response => {
                    if (response.status === 401 && !isRetry && requireAuth) {
                        return new Promise((resolve, reject) => {
                            this.pendingRequests.push(() => {
                                this._requestDtc(apiPath, options, true).then(resolve).catch(reject);
                            });
                            this.refreshAccessToken().catch(reject);
                        });
                    }

                    if (!response.ok) {
                        if (!requireAuth) {
                            return response.json().catch(() => null);
                        }
                        return response.text().then(() => null);
                    }

                    return response.json();
                })
                .catch(error => {
                    throw error;
                });
        }

        getMemberCenterProfile() {
            if (this.memberCenterProfile) {
                return Promise.resolve(this.memberCenterProfile);
            }

            if (this.memberCenterProfilePromise) {
                return this.memberCenterProfilePromise;
            }

            this.memberCenterProfilePromise = this._requestDtc('/member-center/profile?storeId=' + this.storeId, {
                method: 'GET',
            }).then(resp => {
                if (resp && resp.code === '000000') {
                    this.memberCenterProfile = resp.data;
                    return resp.data;
                }
                return null;
            }).finally(() => {
                this.memberCenterProfilePromise = null;
            });

            return this.memberCenterProfilePromise;
        }

        getMemberCenterAssets() {
            if (this.memberCenterAssets) {
                return Promise.resolve(this.memberCenterAssets);
            }

            if (this.memberCenterAssetsPromise) {
                return this.memberCenterAssetsPromise;
            }

            this.memberCenterAssetsPromise = this._requestDtc('/member-center/assets', {
                method: 'GET',
            }).then(resp => {
                if (resp && resp.code === '000000') {
                    this.memberCenterAssets = resp.data;
                    return resp.data;
                }
                return null;
            }).finally(() => {
                this.memberCenterAssetsPromise = null;
            });

            return this.memberCenterAssetsPromise;
        }

        getAcceptLanguage() {
            const shopifyLocale = (window.Shopify?.locale || 'en').toLowerCase();
            const shopifyCountry = (window.Shopify?.country || 'US').toUpperCase();
            const langKey = shopifyLocale.split('-')[0];

            const localeMap = {
                en: 'en-US',
                de: 'de-DE',
                ja: 'ja-JP',
                zh: 'zh-CN',
                cs: 'cs-CZ',
                da: 'da-DK',
                es: 'es-ES',
                fr: shopifyCountry === 'CA' ? 'fr-CA' : 'fr-FR',
                it: 'it-IT',
                nl: 'nl-NL',
                pl: 'pl-PL',
                ru: 'ru-RU',
                tr: 'tr-TR',
                uk: 'uk-UA',
                pt: 'pt-PT',
                ko: 'ko-KR',
                sv: 'sv-SE',
            };

            return localeMap[langKey] || 'en-US';
        }

        getMemberCenterEarnTasks(earnType, acceptLanguage) {
            const type = earnType === 'rays' ? 'rays' : 'miles';
            const apiPath = type === 'rays' ? '/page_bonus_points_task' : '/member-center/miles-tasks';
            const cacheKey = type === 'rays' ? 'memberCenterRaysTasks' : 'memberCenterMilesTasks';
            const cacheLangKey = `${cacheKey}Lang`;
            const lang = acceptLanguage || this.getAcceptLanguage();

            if (this[cacheKey] && this[cacheLangKey] === lang) {
                return Promise.resolve(this[cacheKey]);
            }

            const requestOptions = {
                method: 'GET',
                requireAuth: false,
                acceptLanguage: lang,
            };

            return type === 'miles'
                ? this._requestDtc(`${apiPath}?storeId=${this.storeId}`, requestOptions).then(resp => {
                    if (resp && resp.code === '000000') {
                        this[cacheKey] = resp.data;
                        this[cacheLangKey] = lang;
                        return resp.data;
                    }
                    return null;
                })
                : this._request(`${apiPath}?pageNum=1&pageSize=100&platformId=${this.storeId}`, requestOptions).then(resp => {
                    if (resp && resp.code === '000000') {
                        this[cacheKey] = resp.data;
                        this[cacheLangKey] = lang;
                        return resp.data;
                    }
                    return null;
                });
        }

        initBenefitsExpand() {
            const expandBtn = document.getElementById('rg-benefits-expand-btn');
            const benefitsGrid = document.getElementById('rg-benefits-grid');
            const userLoginSection = document.querySelector('.user-login-section-container');
            
            if (!expandBtn || !benefitsGrid) {
                return;
            }
            
            // 移除之前的事件监听器（如果存在）
            const newExpandBtn = expandBtn.cloneNode(true);
            expandBtn.parentNode.replaceChild(newExpandBtn, expandBtn);
            
            // 添加新的事件监听器
            newExpandBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const isExpanded = benefitsGrid.classList.contains('rg-expanded');
                const expandText = newExpandBtn.querySelector('.rg-benefits-expand-text');
                const allBenefitItems = benefitsGrid.querySelectorAll('.rg-benefit-item');
                
                if (isExpanded) {
                    // Collapse
                    benefitsGrid.classList.remove('rg-expanded');
                    newExpandBtn.classList.remove('rg-expanded');
                    expandText.textContent = `${this.messages.expandButton.viewMore} ${allBenefitItems.length - 1} ${this.messages.expandButton.moreBenefits}`;
                    if (userLoginSection) {
                        userLoginSection.classList.remove('benefits-expanded');
                    }
                } else {
                    // Expand
                    benefitsGrid.classList.add('rg-expanded');
                    newExpandBtn.classList.add('rg-expanded');
                    expandText.textContent = this.messages.expandButton.collapse;
                    if (userLoginSection) {
                        userLoginSection.classList.add('benefits-expanded');
                    }
                }
            });
        }

        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
            return null;
        }

        clearCookies() {
            // 清除 access token 和 refresh token cookies
            // 同时清除 .renogy.cn 和 .renogy.com 域名的 cookie，确保完全清除
            const domains = [".renogy.cn", ".renogy.com"];
            
            if (typeof Cookies !== 'undefined') {
                domains.forEach(domain => {
                    Cookies.remove(this.ACCESS_TOKEN_KEY, { domain });
                    Cookies.remove(this.REFRESH_TOKEN_KEY, { domain });
                });
            } else {
                // 使用原生方法清除（作为备用）
                domains.forEach(domain => {
                    const domainWithoutDot = domain.substring(1); // 移除开头的点
                    document.cookie = `${this.ACCESS_TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
                    document.cookie = `${this.REFRESH_TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
                });
            }
            // 清除实例中的 token
            this.accessToken = null;
            this.refreshToken = null;
        }

        /**
         * 处理登录失效：清除 cookies、显示未登录内容并刷新优惠券数据
         */
        handleLoginExpired() {
            // 清除 cookies
            this.clearCookies();
            
            // 设置登录状态为 false
            this.isLoggedIn = false;
            
            this.initNoLoginContent();
            if (this.memberCouponContainers.length > 0) {
                this.getCouponData();
            }
            if(this.giftCardCouponContainers.length > 0){
                this.getGiftCardCouponData();
            }
            if(this.productCardCouponContainers.length > 0){
                this.getProductCardCouponData();
            }
        }
        
        getAccessToken() {
            return this.accessToken;
        }

        getRefreshToken() {
            return this.refreshToken;
        }
        /**
         * 初始化 Tooltip 功能：信息提示浮层
         */
        initTooltips() {
            // 防止重复初始化
            if (this.tooltipInitialized) {
                return;
            }
            
            const sections = document.querySelectorAll('[user-login-section-container]');
            if (sections.length === 0) {
                return;
            }
            
            const isTouchDevice = this._isTouchDevice();
            
            sections.forEach(section => {
                if (!section.id) return;
                
                const tooltipIcons = section.querySelectorAll('.rg-info-tips-icon');
                if (tooltipIcons.length === 0) return;
                
                
                // 根据设备类型初始化
                if (isTouchDevice) {
                    this._initMobileTooltips(section, tooltipIcons);
                } else {
                    this._initDesktopTooltips(tooltipIcons);
                }
            });
            
            // 窗口大小改变时关闭所有 tooltip
            this._initResizeHandler();
            
            this.tooltipInitialized = true;
        }

        /**
         * 检测是否为触摸设备
         */
        _isTouchDevice() {
            return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || window.innerWidth <= 768;
        }

        /**
         * 初始化移动端 Tooltip（使用事件委托）
         */
        _initMobileTooltips(section, tooltipIcons) {
            
            // 点击事件处理函数
            this.tooltipEventHandlers.click = (e) => {
                const icon = e.target.closest('.rg-info-tips-icon');
                const tooltip = e.target.closest('.rg-info-tips');
                
                // 1. 点击图标
                if (icon) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    const isActive = icon.classList.contains('active');
                    
                    // 先关闭所有 tooltip
                    this._closeAllTooltips(section);
                    
                    // 如果原本不是激活状态，则激活当前 tooltip
                    if (!isActive) {
                        icon.classList.add('active');
                        
                        // 移动端：计算位置
                        const tooltipEl = icon.querySelector('.rg-info-tips');
                        if (tooltipEl && window.innerWidth <= 768) {
                            this._positionMobileTooltip(icon, tooltipEl);
                        }
                        
                        // 移动端禁止页面滚动
                        document.body.style.overflow = 'hidden';
                    } else {
                        // 再次点击同一图标，关闭tooltip
                        document.body.style.overflow = '';
                    }
                    return;
                }
                
                // 2. 点击提示框内容，阻止冒泡（不关闭）
                if (tooltip) {
                    e.stopPropagation();
                    return;
                }
                
                // 3. 点击section内其他区域，关闭所有 tooltip
                this._closeAllTooltips(section);
                document.body.style.overflow = '';
            };
            
            // 绑定点击事件到 section 级别（事件委托）
            section.addEventListener('click', this.tooltipEventHandlers.click);
            
            // 全局点击事件（用于点击section外部关闭） - 只绑定一次
            if (!this.globalClickHandlerBound) {
                this.globalClickHandler = (e) => {
                    // 检查是否点击了 tooltip 相关元素
                    const clickedIcon = e.target.closest('.rg-info-tips-icon');
                    const clickedTooltip = e.target.closest('.rg-info-tips');
                    
                    // 如果点击的不是 tooltip 相关元素，关闭所有激活的 tooltip
                    if (!clickedIcon && !clickedTooltip) {
                        const sections = document.querySelectorAll('[user-login-section-container]');
                        sections.forEach(sec => {
                            const hasActive = sec.querySelector('.rg-info-tips-icon.active');
                            if (hasActive) {
                                this._closeAllTooltips(sec);
                                document.body.style.overflow = '';
                            }
                        });
                    }
                };
                document.addEventListener('click', this.globalClickHandler);
                this.globalClickHandlerBound = true;
            }
        }

        /**
         * 移动端：动态设置提示框位置和小三角
         */
        _positionMobileTooltip(icon, tooltip) {
            // 等待一帧确保 DOM 已渲染并获取正确高度
            requestAnimationFrame(() => {
                // 清除之前的样式
                tooltip.style.removeProperty('top');
                tooltip.style.removeProperty('transform');
                tooltip.style.removeProperty('--arrow-offset');
                
                // 再等一帧获取渲染后的高度
                requestAnimationFrame(() => {
                    const iconRect = icon.getBoundingClientRect();
                    const tooltipRect = tooltip.getBoundingClientRect();
                    
                    // 获取提示框实际高度
                    let tooltipHeight = tooltipRect.height;
                    
                    // 如果获取不到高度，使用 offsetHeight 或默认值
                    if (!tooltipHeight || tooltipHeight < 50) {
                        tooltipHeight = tooltip.offsetHeight || tooltip.scrollHeight || 150;
                    }
                    
                    
                    // 1. 计算 top 位置：图标上方 12px
                    const topPosition = iconRect.top - tooltipHeight - 12;
                    const finalTop = Math.max(20, topPosition); // 确保不超出屏幕顶部
                    
                    // 2. 计算小三角的位置（指向图标的水平中心）
                    const iconCenterX = iconRect.left + iconRect.width / 2;
                    const screenCenterX = window.innerWidth / 2;
                    const arrowOffset = iconCenterX - screenCenterX;
                    
                    // 设置位置和动画
                    tooltip.style.setProperty('top', 0 + 'px', 'important');
                    tooltip.style.setProperty('transform', 'translateX(-50%) translateY(-48px) scale(1)', 'important');
                    tooltip.style.setProperty('--arrow-offset', arrowOffset + 'px');
                    tooltip.style.setProperty('opacity', '1', 'important');
                    tooltip.style.setProperty('visibility', 'visible', 'important');
                    
                });
            });
        }

        /**
         * 初始化桌面端 Tooltip（键盘支持）
         */
        _initDesktopTooltips(tooltipIcons) {
            tooltipIcons.forEach(icon => {
                // 可访问性属性
                icon.setAttribute('tabindex', '0');
                icon.setAttribute('role', 'button');
                // 键盘事件
                icon.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        icon.classList.toggle('active');
                    } else if (e.key === 'Escape') {
                        icon.classList.remove('active');
                    }
                });
                
                // 失去焦点时关闭
                icon.addEventListener('blur', () => {
                    icon.classList.remove('active');
                });
            });
        }

        /**
         * 初始化窗口 resize 处理
         */
        _initResizeHandler() {
            let resizeTimer;
            
            this.tooltipEventHandlers.resize = () => {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(() => {
                    const sections = document.querySelectorAll('[user-login-section-container]');
                    sections.forEach(section => this._closeAllTooltips(section));
                }, 250);
            };
            
            window.addEventListener('resize', this.tooltipEventHandlers.resize);
        }

        /**
         * 关闭指定 section 内的所有 tooltip
         */
        _closeAllTooltips(section) {
            const tooltipIcons = section.querySelectorAll('.rg-info-tips-icon');
            tooltipIcons.forEach(icon => {
                icon.classList.remove('active');
                
                // 清除移动端动态样式
                const tooltip = icon.querySelector('.rg-info-tips');
                if (tooltip && window.innerWidth <= 768) {
                    tooltip.style.removeProperty('opacity');
                    tooltip.style.removeProperty('visibility');
                    tooltip.style.removeProperty('top');
                    tooltip.style.removeProperty('transform');
                    tooltip.style.removeProperty('--arrow-offset');
                }
            });
            
            // 恢复页面滚动（移动端）
            if (this._isTouchDevice()) {
                document.body.style.overflow = '';
            }
        }

        /**
         * 触觉反馈处理
         */
        _handleTouchFeedback() {
            if ('vibrate' in navigator) {
                navigator.vibrate(10);
            }
        }

        /**
         * 清理 Tooltip 事件监听器（如需要）
         */
        _cleanupTooltips() {
            const sections = document.querySelectorAll('[user-login-section-container]');
            
            sections.forEach(section => {
                if (this.tooltipEventHandlers.click) {
                    section.removeEventListener('click', this.tooltipEventHandlers.click);
                }
            });
            
            if (this.tooltipEventHandlers.resize) {
                window.removeEventListener('resize', this.tooltipEventHandlers.resize);
            }
            
            // 移除全局点击事件
            if (this.globalClickHandler) {
                document.removeEventListener('click', this.globalClickHandler);
                this.globalClickHandlerBound = false;
                this.globalClickHandler = null;
            }
            
            this.tooltipInitialized = false;
        }
    }

    const userLoginStatus = new UserLoginStatus();
    userLoginStatus.init();

    if (typeof window !== 'undefined') {
        window.UserLoginStatus = UserLoginStatus;
    }
}
